(function () {
  var ready = function (callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };

  var ensureTndCurrency = function (value) {
    var text = String(value || '').replace(/\u00a0/g, ' ').trim();
    if (!text) {
      return text;
    }

    text = text.replace(/^\s*(?:TND|DT)\s*/i, '').replace(/\s*(?:TND|DT)\s*$/i, '').trim();
    return text ? text + ' TND' : text;
  };

  var initOpener = function () {
    if (window.Lamassat && window.Lamassat.welcomeEnabled === false) {
      return;
    }

    var opener = document.querySelector('[data-lamassat-opener]');
    if (!opener) {
      return;
    }

    var storageKey = 'lamassatIntroSeen';
    var enterButton = opener.querySelector('[data-opener-enter]');
    var logoHost = opener.querySelector('[data-opener-logo]');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opened = false;
    var dragState = {
      active: false,
      startY: 0,
      distance: 0,
      pointerId: null
    };
    var wheelDistance = 0;
    var wheelTimer = null;
    var snapTimer = null;
    var openDuration = reducedMotion ? 320 : 720;

    var storage = {
      get: function (key) {
        try {
          return window.sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      },
      set: function (key, value) {
        try {
          window.sessionStorage.setItem(key, value);
        } catch (error) {
          return false;
        }
        return true;
      }
    };

    if (storage.get(storageKey) === 'true') {
      opener.hidden = true;
      return;
    }

    var revealControls = function () {
      opener.classList.add('is-ready');
      if (enterButton) {
        try {
          enterButton.focus({ preventScroll: true });
        } catch (error) {
          enterButton.focus();
        }
      }
    };

    var getViewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight || 1;
    };

    var clampDragDistance = function (distance) {
      return Math.max(0, Math.min(distance || 0, getViewportHeight()));
    };

    var getRevealThreshold = function () {
      return getViewportHeight() * 0.3;
    };

    var setOpenerOffset = function (distance) {
      opener.style.transform = 'translateY(-' + clampDragDistance(distance) + 'px)';
    };

    var snapOpenerBack = function () {
      if (opened) return;
      window.clearTimeout(snapTimer);
      opener.classList.remove('is-dragging');
      opener.classList.add('is-snapping');
      opener.style.transform = 'translateY(0)';
      snapTimer = window.setTimeout(function () {
        opener.classList.remove('is-snapping');
        if (!opened) {
          opener.style.transform = '';
        }
      }, reducedMotion ? 180 : 760);
    };

    var openSite = function (dragDistance) {
      if (opened) return;
      opened = true;
      window.clearTimeout(wheelTimer);
      window.clearTimeout(snapTimer);
      storage.set(storageKey, 'true');
      document.body.classList.add('lamassat-opener-revealing');
      opener.classList.remove('is-dragging', 'is-snapping');
      opener.classList.add('is-opening');
      opener.style.transform = 'translateY(-' + (Math.max(clampDragDistance(dragDistance), getViewportHeight()) + 24) + 'px)';
      window.setTimeout(function () {
        opener.hidden = true;
        opener.classList.remove('is-visible', 'is-opening', 'is-dragging', 'is-snapping');
        opener.style.transform = '';
        document.body.classList.remove('lamassat-no-scroll', 'lamassat-opener-active', 'lamassat-opener-revealing');
      }, openDuration + 80);
    };

    var revealFallbackLogo = function () {
      if (logoHost) {
        logoHost.classList.add('is-logo-fallback');
      }
      opener.classList.add('is-logo-filled');
      window.setTimeout(revealControls, reducedMotion ? 40 : 260);
    };

    var animateLogo = function () {
      if (!logoHost || !logoHost.getAttribute('data-logo-url') || !window.fetch) {
        revealFallbackLogo();
        return;
      }

      window.fetch(logoHost.getAttribute('data-logo-url'))
        .then(function (response) {
          if (!response.ok) throw new Error('Logo request failed');
          return response.text();
        })
        .then(function (svgText) {
          var template = document.createElement('template');
          template.innerHTML = svgText.trim();
          var sourceSvg = template.content.querySelector('svg');
          if (!sourceSvg) throw new Error('Logo SVG missing');

          logoHost.innerHTML = '';

          var revealSvg = sourceSvg.cloneNode(true);
          var finalSvg = sourceSvg.cloneNode(true);
          revealSvg.classList.add('lamassat-opener__svg--reveal');
          finalSvg.classList.add('lamassat-opener__svg--final');

          [revealSvg, finalSvg].forEach(function (svg) {
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          });

          logoHost.appendChild(revealSvg);
          logoHost.appendChild(finalSvg);

          if (reducedMotion) {
            opener.classList.add('is-logo-filled', 'is-ready');
            return;
          }

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              opener.classList.add('is-logo-revealing');
            });
          });

          window.setTimeout(function () {
            opener.classList.add('is-logo-filled');
            window.setTimeout(revealControls, 260);
          }, 2250);
        })
        .catch(revealFallbackLogo);
    };

    window.scrollTo(0, 0);
    opener.hidden = false;
    document.body.classList.add('lamassat-no-scroll', 'lamassat-opener-active');
    window.requestAnimationFrame(function () {
      opener.classList.add('is-visible');
      animateLogo();
    });

    if (!enterButton) {
      revealControls();
      return;
    }

    var startDrag = function (clientY, pointerId) {
      if (opened || opener.hidden || !opener.classList.contains('is-ready')) {
        return false;
      }

      window.clearTimeout(wheelTimer);
      window.clearTimeout(snapTimer);
      wheelDistance = 0;
      dragState.active = true;
      dragState.startY = clientY;
      dragState.distance = 0;
      dragState.pointerId = pointerId;
      opener.classList.remove('is-snapping');
      opener.classList.add('is-dragging');

      if (pointerId !== null && enterButton.setPointerCapture) {
        try {
          enterButton.setPointerCapture(pointerId);
        } catch (error) {
          return true;
        }
      }

      return true;
    };

    var updateDrag = function (clientY) {
      if (!dragState.active || opened) {
        return;
      }

      dragState.distance = clampDragDistance(dragState.startY - clientY);
      setOpenerOffset(dragState.distance);
    };

    var finishDrag = function () {
      if (!dragState.active || opened) {
        return;
      }

      dragState.active = false;
      if (dragState.pointerId !== null && enterButton.releasePointerCapture) {
        try {
          enterButton.releasePointerCapture(dragState.pointerId);
        } catch (error) {
          // Capture may already be gone if the pointer was cancelled.
        }
      }

      if (dragState.distance >= getRevealThreshold()) {
        openSite(dragState.distance);
      } else {
        snapOpenerBack();
      }

      dragState.pointerId = null;
    };

    enterButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowUp') {
        event.preventDefault();
        openSite(getViewportHeight());
      }
    });

    enterButton.addEventListener('click', function (event) {
      event.preventDefault();
    });

    if (window.PointerEvent) {
      enterButton.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) {
          return;
        }

        if (startDrag(event.clientY, event.pointerId)) {
          event.preventDefault();
        }
      });

      window.addEventListener('pointermove', function (event) {
        if (!dragState.active || dragState.pointerId !== event.pointerId) {
          return;
        }

        event.preventDefault();
        updateDrag(event.clientY);
      }, { passive: false });

      window.addEventListener('pointerup', function (event) {
        if (dragState.pointerId === event.pointerId) {
          finishDrag();
        }
      });

      window.addEventListener('pointercancel', function (event) {
        if (dragState.pointerId === event.pointerId) {
          finishDrag();
        }
      });
    } else {
      enterButton.addEventListener('mousedown', function (event) {
        if (event.button !== 0) {
          return;
        }

        if (startDrag(event.clientY, null)) {
          event.preventDefault();
        }
      });

      window.addEventListener('mousemove', function (event) {
        if (!dragState.active) {
          return;
        }

        event.preventDefault();
        updateDrag(event.clientY);
      }, { passive: false });

      window.addEventListener('mouseup', finishDrag);

      enterButton.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) {
          return;
        }

        if (startDrag(event.touches[0].clientY, null)) {
          event.preventDefault();
        }
      }, { passive: false });

      window.addEventListener('touchmove', function (event) {
        if (!dragState.active || !event.touches || !event.touches.length) {
          return;
        }

        event.preventDefault();
        updateDrag(event.touches[0].clientY);
      }, { passive: false });

      window.addEventListener('touchend', finishDrag);
      window.addEventListener('touchcancel', finishDrag);
    }

    opener.addEventListener('wheel', function (event) {
      if (opened || opener.hidden || !opener.classList.contains('is-ready')) {
        return;
      }

      event.preventDefault();
      window.clearTimeout(wheelTimer);
      opener.classList.add('is-dragging');
      wheelDistance = clampDragDistance(wheelDistance + event.deltaY);
      setOpenerOffset(wheelDistance);

      if (wheelDistance >= getRevealThreshold()) {
        openSite(wheelDistance);
        return;
      }

      wheelTimer = window.setTimeout(function () {
        wheelDistance = 0;
        snapOpenerBack();
      }, 180);
    }, { passive: false });
  };

  var initHeader = function () {
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!drawer) return;

    var openButtons = document.querySelectorAll('[data-drawer-open]');
    var closeButtons = document.querySelectorAll('[data-drawer-close], [data-drawer-link]');

    var openDrawer = function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lamassat-no-scroll');
    };

    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lamassat-no-scroll');
    };

    openButtons.forEach(function (button) {
      button.addEventListener('click', openDrawer);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  };

  var initFooterAccordions = function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-footer-accordion]')).forEach(function (accordion) {
      var triggers = Array.prototype.slice.call(accordion.querySelectorAll('[data-footer-accordion-trigger]'));

      var setPanelState = function (trigger, isOpen) {
        var item = trigger.closest('.lamassat-footer__accordion-item');
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));

        if (!item || !panel) {
          return;
        }

        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
      };

      triggers.forEach(function (trigger) {
        setPanelState(trigger, trigger.getAttribute('aria-expanded') === 'true');

        trigger.addEventListener('click', function () {
          var shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

          triggers.forEach(function (otherTrigger) {
            setPanelState(otherTrigger, otherTrigger === trigger ? shouldOpen : false);
          });
        });
      });

      window.addEventListener('resize', function () {
        triggers.forEach(function (trigger) {
          if (trigger.getAttribute('aria-expanded') === 'true') {
            setPanelState(trigger, true);
          }
        });
      });
    });
  };

  var initHeroSlider = function () {
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
      var index = 0;
      var timer = null;

      if (slides.length <= 1) {
        return;
      }

      var showSlide = function (nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      var start = function () {
        stop();
        timer = window.setInterval(function () {
          showSlide(index + 1);
        }, 4600);
      };

      var stop = function () {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var nextIndex = Number(dot.getAttribute('data-hero-dot'));
          showSlide(nextIndex);
          start();
        });
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);

      showSlide(0);
      start();
    });
  };

  // TEMP PDP PREVIEW MODE - remove/disable once real Shopify products exist.
  var demoProductStorageKey = 'lamassatDemoProduct';

  var escapeHtml = function (value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  var soldOutButtonLabelHtml = '<span class="lamassat-stock-button-label"><span>Rupture de stock</span><small lang="ar" dir="rtl">&#1594;&#1610;&#1585; &#1605;&#1578;&#1608;&#1601;&#1585;</small></span>';
  var soldOutMessage = {
    fr: 'Ce produit est actuellement en rupture de stock.',
    ar: '&#1607;&#1584;&#1575; &#1575;&#1604;&#1605;&#1606;&#1578;&#1580; &#1594;&#1610;&#1585; &#1605;&#1578;&#1608;&#1601;&#1585; &#1581;&#1575;&#1604;&#1610;&#1575;&#1611;.'
  };

  var getVariantInventoryValue = function (variant, camelKey, snakeKey) {
    if (!variant) {
      return null;
    }

    if (Object.prototype.hasOwnProperty.call(variant, camelKey)) {
      return variant[camelKey];
    }

    if (Object.prototype.hasOwnProperty.call(variant, snakeKey)) {
      return variant[snakeKey];
    }

    return null;
  };

  var isLamassatVariantAvailable = function (variant) {
    if (!variant) {
      return false;
    }

    var explicit = getVariantInventoryValue(variant, 'lamassatAvailable', 'lamassat_available');
    if (explicit !== null && explicit !== undefined) {
      return Boolean(explicit);
    }

    var inventoryManagement = getVariantInventoryValue(variant, 'inventoryManagement', 'inventory_management');
    var inventoryQuantity = getVariantInventoryValue(variant, 'inventoryQuantity', 'inventory_quantity');
    var trackedOut = Boolean(inventoryManagement) && inventoryQuantity !== null && inventoryQuantity !== undefined && Number(inventoryQuantity) <= 0;

    return Boolean(variant.available) && !trackedOut;
  };

  var isLamassatProductSoldOut = function (product) {
    if (!product || product.isDemo) {
      return false;
    }

    if (product.isSoldOut) {
      return true;
    }

    return Array.isArray(product.variants) && product.variants.length > 0 && !product.variants.some(isLamassatVariantAvailable);
  };

  var setStockButtonLabel = function (button, selector, available) {
    var labelNode = button ? button.querySelector(selector) : null;
    if (!button || !labelNode) {
      return;
    }

    if (available) {
      labelNode.textContent = button.getAttribute('data-add-label') || button.getAttribute('data-buy-label') || button.getAttribute('data-normal-label') || '';
    } else {
      labelNode.innerHTML = soldOutButtonLabelHtml;
    }
  };

  var readSessionJson = function (key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key));
    } catch (error) {
      return null;
    }
  };

  var writeSessionJson = function (key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return false;
    }

    return true;
  };

  var normalizeDemoLabel = function (badge) {
    var normalizedBadge = String(badge || '').trim();
    var lowerBadge = normalizedBadge.toLowerCase();

    if (!normalizedBadge || lowerBadge === 'nouveau' || lowerBadge === 'nouveaute' || lowerBadge === 'nouveaut\u00e9' || lowerBadge === 'nouveaut&eacute;') {
      return 'NOUVEAUT\u00c9';
    }

    return normalizedBadge.toUpperCase();
  };

  var deliveryBadgeCopy = {
    free: {
      fr: 'Livraison gratuite',
      ar: '\u062a\u0648\u0635\u064a\u0644 \u0645\u062c\u0627\u0646\u064a'
    }
  };

  var isVariantOnSale = function (variant) {
    return Boolean(variant && (variant.onSale || variant.on_sale));
  };

  var isPaidDelivery = function (source, variant) {
    return Boolean((source && (source.deliveryPromotionLocked || source.isSale)) || isVariantOnSale(variant));
  };

  var buildDeliveryBadgeHtml = function (isPaid) {
    if (isPaid) {
      return '';
    }

    var copy = deliveryBadgeCopy.free;

    return [
      '<span class="lamassat-delivery-badge lamassat-delivery-badge--free" data-lamassat-delivery-badge data-delivery-promo-locked="false" aria-label="' + escapeHtml(copy.fr + ' - ' + copy.ar) + '">',
      '<span class="lamassat-delivery-badge__icon" aria-hidden="true">',
      '<svg viewBox="0 0 32 24" focusable="false">',
      '<path d="M2.5 5.5h15v10.8h-15z" />',
      '<path d="M17.5 8.6h4.9l4.2 4.5v3.2h-9.1z" />',
      '<path d="M5.2 19.1h-.8c-1 0-1.9-.8-1.9-1.9v-.9h24.1v.9c0 1-.8 1.9-1.9 1.9h-.8" />',
      '<circle cx="8.2" cy="19.1" r="2.4" />',
      '<circle cx="20.9" cy="19.1" r="2.4" />',
      '<path d="M6 9h6.4M6 12.5h4.4" />',
      '</svg>',
      '</span>',
      '<span class="lamassat-delivery-badge__content">',
      '<span class="lamassat-delivery-badge__fr" data-delivery-fr>' + escapeHtml(copy.fr) + '</span>',
      '<span class="lamassat-delivery-badge__ar" lang="ar" dir="rtl" data-delivery-ar>' + escapeHtml(copy.ar) + '</span>',
      '</span>',
      '</span>'
    ].join('');
  };

  var setDeliveryBadgeState = function (badge, isPaid) {
    if (!badge) {
      return;
    }

    badge.hidden = isPaid;
    badge.setAttribute('aria-hidden', isPaid ? 'true' : 'false');

    if (isPaid) {
      return;
    }

    var copy = deliveryBadgeCopy.free;
    var frNode = badge.querySelector('[data-delivery-fr]');
    var arNode = badge.querySelector('[data-delivery-ar]');

    badge.classList.add('lamassat-delivery-badge--free');
    badge.setAttribute('aria-label', copy.fr + ' - ' + copy.ar);

    if (frNode) {
      frNode.textContent = copy.fr;
    }

    if (arNode) {
      arNode.textContent = copy.ar;
    }
  };

  var collectDemoGallery = function (card, mainImage) {
    var section = card.closest('.lamassat-product-list');
    var cards = section ? Array.prototype.slice.call(section.querySelectorAll('[data-demo-product]')) : [];
    var images = [];

    if (mainImage) {
      images.push(mainImage);
    }

    cards.forEach(function (item) {
      var image = item.getAttribute('data-demo-image') || '';
      if (image && images.indexOf(image) === -1) {
        images.push(image);
      }
    });

    if (!images.length && mainImage) {
      images.push(mainImage);
    }

    return images;
  };

  var getDemoProductFromCard = function (card) {
    if (!card) {
      return null;
    }

    var image = card.getAttribute('data-demo-image') || '';
    var fallbackImage = card.querySelector('img');
    if (!image && fallbackImage) {
      image = fallbackImage.currentSrc || fallbackImage.src || '';
    }

    return {
      title: card.getAttribute('data-demo-title') || 'Lamassat',
      price: ensureTndCurrency(card.getAttribute('data-demo-price') || ''),
      image: image,
      badge: card.getAttribute('data-demo-badge') || '',
      compare: ensureTndCurrency(card.getAttribute('data-demo-compare') || ''),
      arabicTitle: card.getAttribute('data-demo-arabic-title') || '',
      gallery: collectDemoGallery(card, image)
    };
  };

  var quickViewModal = null;
  var quickViewLastFocus = null;
  var quickViewProduct = null;
  var quickViewSelectedSize = '';
  var quickViewSizePosition = null;

  var quickViewFallbackDescription = 'Une pi&egrave;ce raffin&eacute;e pens&eacute;e pour sublimer votre &eacute;l&eacute;gance avec une coupe fluide, des d&eacute;tails d&eacute;licats et une finition soign&eacute;e.';
  var quickViewFallbackArabicDescription = '&#1602;&#1591;&#1593;&#1577; &#1585;&#1575;&#1602;&#1610;&#1577; &#1589;&#1605;&#1605;&#1578; &#1604;&#1578;&#1605;&#1606;&#1581;&#1603; &#1573;&#1591;&#1604;&#1575;&#1604;&#1577; &#1571;&#1606;&#1610;&#1602;&#1577; &#1576;&#1578;&#1601;&#1575;&#1589;&#1610;&#1604; &#1606;&#1575;&#1593;&#1605;&#1577; &#1608;&#1604;&#1605;&#1587;&#1577; &#1601;&#1575;&#1582;&#1585;&#1577;.';
  var quickViewDemoMessage = 'Aper&ccedil;u seulement &mdash; produit non connect&eacute; &agrave; Shopify.';
  var quickViewDemoArabicMessage = '&#1605;&#1593;&#1575;&#1610;&#1606;&#1577; &#1601;&#1602;&#1591; &mdash; &#1575;&#1604;&#1605;&#1606;&#1578;&#1580; &#1594;&#1610;&#1585; &#1605;&#1585;&#1576;&#1608;&#1591; &#1576;&#1593;&#1583; &#1576;&#1588;&#1608;&#1576;&#1610;&#1601;&#1575;&#1610;.';

  // Preview-only Arabic title fallbacks until product metafields exist.
  var quickViewArabicTitleFallbacks = {
    'caftan layal': '&#1602;&#1601;&#1591;&#1575;&#1606; &#1604;&#1610;&#1575;&#1604;',
    'robe delicatesse': '&#1601;&#1587;&#1578;&#1575;&#1606; &#1575;&#1604;&#1585;&#1602;&#1577;',
    'caftan nour': '&#1602;&#1601;&#1591;&#1575;&#1606; &#1606;&#1608;&#1585;',
    'robe sofia': '&#1601;&#1587;&#1578;&#1575;&#1606; &#1589;&#1608;&#1601;&#1610;&#1575;'
  };

  var normalizeQuickViewKey = function (value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  };

  var getQuickViewArabicTitle = function (product) {
    if (product.arabicTitle) {
      return escapeHtml(product.arabicTitle);
    }

    return quickViewArabicTitleFallbacks[normalizeQuickViewKey(product.title)] || escapeHtml(product.title);
  };

  var getQuickViewBadgeArabic = function (badge) {
    var normalizedBadge = normalizeQuickViewKey(badge);

    if (normalizedBadge.indexOf('promo') !== -1) {
      return '&#1578;&#1582;&#1601;&#1610;&#1590;&#1575;&#1578;';
    }

    return '&#1580;&#1583;&#1610;&#1583;&#1575;';
  };

  var readQuickViewProductJson = function (card) {
    var node = card ? card.querySelector('[data-quick-view-product]') : null;
    if (!node) {
      return {};
    }

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  var normalizeQuickViewImages = function (images, card, title) {
    var normalizedImages = Array.isArray(images) ? images.filter(function (image) {
      return image && (image.src || typeof image === 'string');
    }).map(function (image) {
      if (typeof image === 'string') {
        return {
          src: image,
          thumb: image,
          alt: title
        };
      }

      return {
        src: image.src || image.thumb || '',
        thumb: image.thumb || image.src || '',
        alt: image.alt || title
      };
    }) : [];

    if (card && card.hasAttribute('data-demo-product')) {
      var demoProduct = getDemoProductFromCard(card);
      if (demoProduct && demoProduct.gallery && demoProduct.gallery.length > normalizedImages.length) {
        normalizedImages = demoProduct.gallery.map(function (image) {
          return {
            src: image,
            thumb: image,
            alt: title
          };
        });
      }
    }

    if (!normalizedImages.length && card) {
      var fallbackImage = card.querySelector('.lamassat-product-card__media img');
      if (fallbackImage) {
        normalizedImages.push({
          src: fallbackImage.currentSrc || fallbackImage.src || '',
          thumb: fallbackImage.currentSrc || fallbackImage.src || '',
          alt: fallbackImage.alt || title
        });
      }
    }

    return normalizedImages.filter(function (image) {
      return Boolean(image.src);
    });
  };

  var getQuickViewProductFromCard = function (card) {
    var jsonProduct = readQuickViewProductJson(card);
    var demoProduct = card && card.hasAttribute('data-demo-product') ? getDemoProductFromCard(card) : null;
    var title = jsonProduct.title || (demoProduct && demoProduct.title) || 'Lamassat';
    var deliveryBadge = card ? card.querySelector('[data-lamassat-delivery-badge]') : null;
    var product = {
      title: title,
      arabicTitle: jsonProduct.arabicTitle || (demoProduct && demoProduct.arabicTitle) || '',
      price: ensureTndCurrency(jsonProduct.price || (demoProduct && demoProduct.price) || ''),
      url: jsonProduct.url || (card ? (card.querySelector('.lamassat-product-card__link') || {}).href : '') || '#',
      badge: jsonProduct.badge || (demoProduct && demoProduct.badge) || '',
      isSale: Boolean(jsonProduct.isSale),
      isNew: Boolean(jsonProduct.isNew),
      deliveryPromotionLocked: Boolean(jsonProduct.deliveryPromotionLocked || (deliveryBadge && deliveryBadge.getAttribute('data-delivery-promo-locked') === 'true')),
      comparePrice: ensureTndCurrency(jsonProduct.comparePrice || (demoProduct && demoProduct.compare) || ''),
      isDemo: Boolean(jsonProduct.isDemo || demoProduct),
      isSoldOut: Boolean(jsonProduct.isSoldOut),
      description: jsonProduct.description || '',
      arabicDescription: jsonProduct.arabicDescription || '',
      selectedVariantId: jsonProduct.selectedVariantId || null,
      images: normalizeQuickViewImages(jsonProduct.images, card, title),
      options: Array.isArray(jsonProduct.options) ? jsonProduct.options : [],
      variants: Array.isArray(jsonProduct.variants) ? jsonProduct.variants : []
    };

    if (!product.url || product.url === '#') {
      product.url = '#';
    }

    return product;
  };

  var ensureQuickViewModal = function () {
    if (quickViewModal) {
      return quickViewModal;
    }

    document.body.insertAdjacentHTML('beforeend', [
      '<div class="lamassat-quick-view" data-quick-view-modal hidden>',
      '<div class="lamassat-quick-view__backdrop" data-quick-view-close aria-hidden="true"></div>',
      '<div class="lamassat-quick-view__dialog" role="dialog" aria-modal="true" aria-labelledby="LamassatQuickViewTitle" tabindex="-1">',
      '<button class="lamassat-quick-view__close" type="button" aria-label="Fermer l&apos;aper&ccedil;u rapide" data-quick-view-close>',
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5 19 19"></path><path d="M19 5 5 19"></path></svg>',
      '</button>',
      '<div class="lamassat-quick-view__body" data-quick-view-body></div>',
      '</div>',
      '</div>'
    ].join(''));

    quickViewModal = document.querySelector('[data-quick-view-modal]');
    return quickViewModal;
  };

  var getQuickViewSizeConfig = function (product) {
    var options = Array.isArray(product.options) ? product.options : [];
    var sizeOption = options.filter(function (option) {
      var name = normalizeQuickViewKey(option.name);
      return name === 'taille' || name === 'size' || name.indexOf('taille') !== -1 || name.indexOf('size') !== -1;
    })[0];

    if (sizeOption && Array.isArray(sizeOption.values) && sizeOption.values.length) {
      return {
        values: sizeOption.values,
        position: Number(sizeOption.position) || (options.indexOf(sizeOption) + 1),
        isFallback: false
      };
    }

    return {
      values: ['T1 (36-40)', 'T2 (42-46)'],
      position: null,
      isFallback: true
    };
  };

  var getQuickViewVariant = function (product, sizeValue, sizePosition) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) {
      return null;
    }

    if (!sizePosition) {
      return variants.filter(function (variant) {
        return Number(variant.id) === Number(product.selectedVariantId);
      })[0] || variants.filter(function (variant) {
        return isLamassatVariantAvailable(variant);
      })[0] || variants[0];
    }

    return variants.filter(function (variant) {
      return isLamassatVariantAvailable(variant) && variant.options && variant.options[sizePosition - 1] === sizeValue;
    })[0] || variants.filter(function (variant) {
      return variant.options && variant.options[sizePosition - 1] === sizeValue;
    })[0] || null;
  };

  var hasQuickViewAvailableVariant = function (product, sizeValue, sizePosition) {
    if (product.isDemo || !product.variants || !product.variants.length || !sizePosition) {
      return true;
    }

    return product.variants.some(function (variant) {
      return isLamassatVariantAvailable(variant) && variant.options && variant.options[sizePosition - 1] === sizeValue;
    });
  };

  var buildQuickViewThumbMarkup = function (image, index) {
    var active = index === 0;

    return [
      '<button class="lamassat-quick-view__thumb' + (active ? ' is-active' : '') + '" type="button" aria-label="Afficher l&#39;image ' + (index + 1) + '" aria-current="' + (active ? 'true' : 'false') + '" data-quick-view-thumb="' + index + '">',
      '<img src="' + escapeHtml(image.thumb || image.src) + '" alt="' + escapeHtml(image.alt || '') + '" width="160" height="210" loading="lazy">',
      '</button>'
    ].join('');
  };

  var buildQuickViewSizeMarkup = function (product, sizeConfig) {
    return sizeConfig.values.map(function (value, index) {
      var available = hasQuickViewAvailableVariant(product, value, sizeConfig.position);
      var selected = value === quickViewSelectedSize || (!quickViewSelectedSize && index === 0);

      return '<button class="lamassat-quick-view__size' + (selected ? ' is-selected' : '') + '" type="button" role="radio" aria-checked="' + (selected ? 'true' : 'false') + '" data-quick-view-size="' + escapeHtml(value) + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' + escapeHtml(value) + '</button>';
    }).join('');
  };

  var buildQuickViewMarkup = function (product) {
    var images = product.images && product.images.length ? product.images : [];
    var mainImage = images[0] || null;
    var label = product.badge ? normalizeDemoLabel(product.badge) : '';
    var sizeConfig = getQuickViewSizeConfig(product);
    var firstAvailableSize = sizeConfig.values.filter(function (value) {
      return hasQuickViewAvailableVariant(product, value, sizeConfig.position);
    })[0] || sizeConfig.values[0] || '';

    quickViewSelectedSize = quickViewSelectedSize && sizeConfig.values.indexOf(quickViewSelectedSize) !== -1 ? quickViewSelectedSize : firstAvailableSize;
    quickViewSizePosition = sizeConfig.position;

    var initialVariant = getQuickViewVariant(product, quickViewSelectedSize, quickViewSizePosition);
    var badgeItemsHtml = '';
    if (product.isSale || product.isNew) {
      badgeItemsHtml += (product.isSale ? '<span class="lamassat-badge lamassat-badge--promo">PROMO</span>' : '')
        + (product.isNew ? '<span class="lamassat-badge lamassat-badge--new">NOUVEAUTÉ</span>' : '');
    } else if (label) {
      badgeItemsHtml += '<span class="lamassat-badge lamassat-badge--new">' + escapeHtml(label) + '</span>';
    }
    badgeItemsHtml += buildDeliveryBadgeHtml(isPaidDelivery(product, initialVariant));
    var badgesHtml = '<div class="lamassat-quick-view__badges">' + badgeItemsHtml + '</div>';

    var hasCompare = product.isSale && product.comparePrice;
    var priceHtml = '<p class="lamassat-quick-view__price' + (hasCompare ? ' is-sale' : '') + '" data-quick-view-price-wrap>'
      + '<span data-quick-view-price>' + escapeHtml(ensureTndCurrency(product.price)) + '</span>'
      + (hasCompare ? '<s class="lamassat-quick-view__compare" data-quick-view-compare>' + escapeHtml(ensureTndCurrency(product.comparePrice)) + '</s>' : '')
      + '</p>';
    var stockStatusHtml = '<p class="lamassat-stock-status" data-quick-view-stock-status hidden><span>Rupture de stock</span><small lang="ar" dir="rtl">&#1594;&#1610;&#1585; &#1605;&#1578;&#1608;&#1601;&#1585;</small></p>';

    return [
      '<div class="lamassat-quick-view__gallery' + (images.length <= 1 ? ' lamassat-quick-view__gallery--single' : '') + '">',
      '<div class="lamassat-quick-view__thumbs" aria-label="Images du produit">',
      images.map(buildQuickViewThumbMarkup).join(''),
      '</div>',
      '<div class="lamassat-quick-view__main-image">',
      mainImage ? '<img src="' + escapeHtml(mainImage.src) + '" alt="' + escapeHtml(mainImage.alt || product.title) + '" width="1000" height="1300" data-quick-view-main-image>' : '<span class="lamassat-quick-view__placeholder">Lamassat</span>',
      '</div>',
      '</div>',
      '<div class="lamassat-quick-view__summary">',
      badgesHtml,
      '<h2 class="lamassat-quick-view__title" id="LamassatQuickViewTitle">' + escapeHtml(product.title) + '</h2>',
      '<p class="lamassat-quick-view__arabic-title lamassat-quick-view__arabic" lang="ar" dir="rtl">' + getQuickViewArabicTitle(product) + '</p>',
      priceHtml,
      stockStatusHtml,
      '<div class="lamassat-quick-view__rule" aria-hidden="true"><span></span></div>',
      '<p class="lamassat-quick-view__description">' + (product.description ? escapeHtml(product.description) : quickViewFallbackDescription) + '</p>',
      '<p class="lamassat-quick-view__arabic-description lamassat-quick-view__arabic" lang="ar" dir="rtl">' + (product.arabicDescription ? escapeHtml(product.arabicDescription) : quickViewFallbackArabicDescription) + '</p>',
      '<div class="lamassat-quick-view__form">',
      '<fieldset class="lamassat-quick-view__fieldset">',
      '<legend class="lamassat-quick-view__legend"><span>TAILLE</span><span class="lamassat-quick-view__arabic" lang="ar" dir="rtl">&#1575;&#1604;&#1605;&#1602;&#1575;&#1587;</span></legend>',
      '<div class="lamassat-quick-view__sizes" role="radiogroup" aria-label="Taille">',
      buildQuickViewSizeMarkup(product, sizeConfig),
      '</div>',
      '</fieldset>',
      '<div>',
      '<label class="lamassat-quick-view__quantity-label" for="LamassatQuickViewQuantity"><span>QUANTIT&Eacute;</span><span class="lamassat-quick-view__arabic" lang="ar" dir="rtl">&#1575;&#1604;&#1603;&#1605;&#1610;&#1577;</span></label>',
      '<div class="lamassat-quick-view__quantity" data-quick-view-quantity>',
      '<button type="button" aria-label="Diminuer la quantit&eacute;" data-quick-view-quantity-minus>&minus;</button>',
      '<input id="LamassatQuickViewQuantity" type="number" value="1" min="1" inputmode="numeric" data-quick-view-quantity-input>',
      '<button type="button" aria-label="Augmenter la quantit&eacute;" data-quick-view-quantity-plus>+</button>',
      '</div>',
      '</div>',
      '<div class="lamassat-quick-view__actions">',
      '<button class="lamassat-quick-view__add" type="button" data-quick-view-add data-normal-label="AJOUTER AU PANIER"><span data-quick-view-add-label>AJOUTER AU PANIER</span></button>',
      '<button class="lamassat-quick-view__buy" type="button" data-quick-view-buy data-normal-label="ACHETER MAINTENANT"><span data-quick-view-buy-label>ACHETER MAINTENANT</span></button>',
      '</div>',
      '<p class="lamassat-quick-view__message" data-quick-view-message></p>',
      '<a class="lamassat-quick-view__details" href="' + escapeHtml(product.url || '#') + '" data-quick-view-details>',
      '<span>VOIR PLUS DE D&Eacute;TAILS</span>',
      '<svg viewBox="0 0 32 12" aria-hidden="true" focusable="false"><path d="M1 6h27"></path><path d="m23.5 1.5 5 4.5-5 4.5"></path></svg>',
      '</a>',
      '</div>',
      '</div>'
    ].join('');
  };

  var setQuickViewMainImage = function (index) {
    if (!quickViewModal || !quickViewProduct || !quickViewProduct.images[index]) {
      return;
    }

    var image = quickViewProduct.images[index];
    var mainImage = quickViewModal.querySelector('[data-quick-view-main-image]');
    if (mainImage) {
      mainImage.src = image.src;
      mainImage.alt = image.alt || quickViewProduct.title || '';
    }

    Array.prototype.slice.call(quickViewModal.querySelectorAll('[data-quick-view-thumb]')).forEach(function (thumb) {
      var active = Number(thumb.getAttribute('data-quick-view-thumb')) === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  var updateQuickViewVariantState = function () {
    if (!quickViewModal || !quickViewProduct) {
      return null;
    }

    var variant = getQuickViewVariant(quickViewProduct, quickViewSelectedSize, quickViewSizePosition);
    var priceNode = quickViewModal.querySelector('[data-quick-view-price]');
    var compareNode = quickViewModal.querySelector('[data-quick-view-compare]');
    var priceWrap = quickViewModal.querySelector('[data-quick-view-price-wrap]');
    var deliveryBadge = quickViewModal.querySelector('[data-lamassat-delivery-badge]');
    var addButton = quickViewModal.querySelector('[data-quick-view-add]');
    var buyButton = quickViewModal.querySelector('[data-quick-view-buy]');
    var actionButtons = Array.prototype.slice.call(quickViewModal.querySelectorAll('[data-quick-view-add], [data-quick-view-buy]'));
    var stockStatus = quickViewModal.querySelector('[data-quick-view-stock-status]');
    var messageNode = quickViewModal.querySelector('[data-quick-view-message]');
    var available = quickViewProduct.isDemo || (!isLamassatProductSoldOut(quickViewProduct) && (!quickViewProduct.variants.length || isLamassatVariantAvailable(variant)));

    if (priceNode && variant && variant.priceFormatted) {
      priceNode.textContent = ensureTndCurrency(variant.priceFormatted);
    }

    if (compareNode && priceWrap && variant) {
      if (variant && variant.onSale && variant.compareAtPriceFormatted) {
        compareNode.textContent = ensureTndCurrency(variant.compareAtPriceFormatted);
        compareNode.hidden = false;
        priceWrap.classList.add('is-sale');
      } else {
        compareNode.hidden = true;
        priceWrap.classList.remove('is-sale');
      }
    }

    setDeliveryBadgeState(deliveryBadge, isPaidDelivery(quickViewProduct, variant));

    actionButtons.forEach(function (button) {
      button.disabled = !available;
    });

    setStockButtonLabel(addButton, '[data-quick-view-add-label]', available);
    setStockButtonLabel(buyButton, '[data-quick-view-buy-label]', available);

    if (stockStatus) {
      stockStatus.hidden = available;
      stockStatus.classList.toggle('is-visible', !available);
    }

    if (available && messageNode) {
      messageNode.classList.remove('is-visible');
      messageNode.textContent = '';
    }

    return variant;
  };

  var setQuickViewSize = function (sizeValue) {
    quickViewSelectedSize = sizeValue;

    Array.prototype.slice.call(quickViewModal.querySelectorAll('[data-quick-view-size]')).forEach(function (button) {
      var selected = button.getAttribute('data-quick-view-size') === sizeValue;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    updateQuickViewVariantState();
  };

  var getQuickViewQuantity = function () {
    var input = quickViewModal ? quickViewModal.querySelector('[data-quick-view-quantity-input]') : null;
    var quantity = input ? Number(input.value) : 1;
    return Math.max(1, Math.floor(quantity || 1));
  };

  var setQuickViewQuantity = function (quantity) {
    var input = quickViewModal ? quickViewModal.querySelector('[data-quick-view-quantity-input]') : null;
    if (input) {
      input.value = String(Math.max(1, Math.floor(Number(quantity) || 1)));
    }
  };

  var showQuickViewMessage = function (message, arabicMessage) {
    var messageNode = quickViewModal ? quickViewModal.querySelector('[data-quick-view-message]') : null;
    if (!messageNode) {
      return;
    }

    messageNode.innerHTML = '<span>' + message + '</span><span class="lamassat-quick-view__arabic" lang="ar" dir="rtl">' + arabicMessage + '</span>';
    messageNode.classList.add('is-visible');
  };

  var addQuickViewProductToCart = function (redirectToCheckout) {
    var variant = updateQuickViewVariantState();

    if (!quickViewProduct) {
      return;
    }

    if (quickViewProduct.isDemo) {
      // Demo product → add to the client-side demo cart so the cart can be tested.
      var demoImage = (quickViewProduct.images && quickViewProduct.images[0] && quickViewProduct.images[0].src) || '';
      LamassatCart.add({
        isDemo: true,
        title: quickViewProduct.title,
        variant: quickViewSelectedSize || '',
        priceMillimes: LamassatCart.parseDemoPrice(quickViewProduct.price),
        image: demoImage,
        url: quickViewProduct.url,
        quantity: getQuickViewQuantity()
      });
      closeQuickView();
      return;
    }

    if (!variant || !variant.id || !isLamassatVariantAvailable(variant) || isLamassatProductSoldOut(quickViewProduct)) {
      showQuickViewMessage(soldOutMessage.fr, soldOutMessage.ar);
      return;
    }

    LamassatCart.add({
      isDemo: false,
      variantId: variant.id,
      quantity: getQuickViewQuantity()
    }).then(function () {
      closeQuickView();
      if (redirectToCheckout) {
        window.location.href = '/checkout';
      }
    }).catch(function () {
      showQuickViewMessage('Impossible d&apos;ajouter le produit pour le moment.', '&#1578;&#1593;&#1584;&#1585; &#1573;&#1590;&#1575;&#1601;&#1577; &#1575;&#1604;&#1605;&#1606;&#1578;&#1580; &#1581;&#1575;&#1604;&#1610;&#1575;.');
    });
  };

  var getQuickViewDemoStorageProduct = function (product) {
    var gallery = product.images.map(function (image) {
      return image.src;
    });

    return {
      title: product.title,
      price: product.price,
      image: gallery[0] || '',
      badge: product.badge,
      compare: product.comparePrice || '',
      arabicTitle: product.arabicTitle,
      gallery: gallery
    };
  };

  var closeQuickView = function () {
    if (!quickViewModal || quickViewModal.hidden) {
      return;
    }

    quickViewModal.classList.remove('is-open');
    document.body.classList.remove('lamassat-quick-view-open');
    window.setTimeout(function () {
      if (quickViewModal) {
        quickViewModal.hidden = true;
      }
    }, 180);

    if (quickViewLastFocus && typeof quickViewLastFocus.focus === 'function') {
      try {
        quickViewLastFocus.focus({ preventScroll: true });
      } catch (error) {
        quickViewLastFocus.focus();
      }
    }
  };

  var openQuickView = function (card, trigger) {
    var modal = ensureQuickViewModal();
    var body = modal.querySelector('[data-quick-view-body]');

    quickViewProduct = getQuickViewProductFromCard(card);
    quickViewSelectedSize = '';
    quickViewLastFocus = trigger || document.activeElement;
    body.innerHTML = buildQuickViewMarkup(quickViewProduct);
    updateQuickViewVariantState();

    modal.hidden = false;
    document.body.classList.add('lamassat-quick-view-open');
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var closeButton = modal.querySelector('.lamassat-quick-view__close');
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });
  };

  var trapQuickViewFocus = function (event) {
    if (!quickViewModal || quickViewModal.hidden || event.key !== 'Tab') {
      return;
    }

    var focusable = Array.prototype.slice.call(quickViewModal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return element.offsetParent !== null;
    });

    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  var initQuickView = function () {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-quick-view-trigger]'));
    if (!triggers.length) {
      return;
    }

    ensureQuickViewModal();

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openQuickView(trigger.closest('.lamassat-product-card'), trigger);
      });
    });

    quickViewModal.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-quick-view-thumb]');
      var size = event.target.closest('[data-quick-view-size]');
      var details = event.target.closest('[data-quick-view-details]');

      if (event.target.closest('[data-quick-view-close]')) {
        event.preventDefault();
        closeQuickView();
        return;
      }

      if (thumb) {
        event.preventDefault();
        setQuickViewMainImage(Number(thumb.getAttribute('data-quick-view-thumb')));
        return;
      }

      if (size && !size.disabled) {
        event.preventDefault();
        setQuickViewSize(size.getAttribute('data-quick-view-size'));
        return;
      }

      if (event.target.closest('[data-quick-view-quantity-minus]')) {
        event.preventDefault();
        setQuickViewQuantity(getQuickViewQuantity() - 1);
        return;
      }

      if (event.target.closest('[data-quick-view-quantity-plus]')) {
        event.preventDefault();
        setQuickViewQuantity(getQuickViewQuantity() + 1);
        return;
      }

      if (event.target.closest('[data-quick-view-add]')) {
        event.preventDefault();
        addQuickViewProductToCart(false);
        return;
      }

      if (event.target.closest('[data-quick-view-buy]')) {
        event.preventDefault();
        addQuickViewProductToCart(true);
        return;
      }

      if (details && quickViewProduct && quickViewProduct.isDemo) {
        event.preventDefault();
        writeSessionJson(demoProductStorageKey, getQuickViewDemoStorageProduct(quickViewProduct));
        window.location.href = details.href;
      }
    });

    quickViewModal.addEventListener('change', function (event) {
      if (event.target.matches('[data-quick-view-quantity-input]')) {
        setQuickViewQuantity(event.target.value);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!quickViewModal || quickViewModal.hidden) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuickView();
      }

      trapQuickViewFocus(event);
    });
  };

  var initDemoProductLinks = function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-demo-product] a[href*="pdp-preview=1"]')).forEach(function (link) {
      link.addEventListener('click', function (event) {
        var card = link.closest('[data-demo-product]');
        var productData = getDemoProductFromCard(card);

        if (!productData) {
          return;
        }

        event.preventDefault();
        writeSessionJson(demoProductStorageKey, productData);
        window.location.href = link.href;
      });
    });
  };

  var buildDemoThumbnailMarkup = function (image, product, index) {
    var active = index === 0;

    return [
      '<button class="lamassat-product-gallery__thumb' + (active ? ' is-active' : '') + '" type="button" aria-label="Afficher l&#39;image ' + (index + 1) + '" aria-current="' + (active ? 'true' : 'false') + '" data-product-thumbnail data-media-id="' + (index + 1) + '" data-media-index="' + index + '" data-media-type="image" data-full-src="' + escapeHtml(image) + '" data-full-alt="' + escapeHtml(product.title) + '" data-full-width="1400" data-full-height="1400">',
      '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="280" height="280" loading="lazy">',
      '</button>'
    ].join('');
  };

  var buildProductLightboxMarkup = function () {
    return [
      '<div class="lamassat-product-lightbox" data-product-lightbox aria-hidden="true" hidden>',
      '<button class="lamassat-product-lightbox__backdrop" type="button" aria-label="Fermer la galerie" data-product-lightbox-close></button>',
      '<div class="lamassat-product-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Images du produit" tabindex="-1" data-product-lightbox-dialog>',
      '<button class="lamassat-product-lightbox__close" type="button" aria-label="Fermer" data-product-lightbox-close>&times;</button>',
      '<button class="lamassat-product-lightbox__arrow lamassat-product-lightbox__arrow--prev" type="button" aria-label="Image pr&eacute;c&eacute;dente" data-product-lightbox-prev>&#8249;</button>',
      '<div class="lamassat-product-lightbox__stage" data-product-lightbox-stage>',
      '<div class="lamassat-product-lightbox__media" data-product-lightbox-media></div>',
      '</div>',
      '<button class="lamassat-product-lightbox__arrow lamassat-product-lightbox__arrow--next" type="button" aria-label="Image suivante" data-product-lightbox-next>&#8250;</button>',
      '<div class="lamassat-product-lightbox__counter" data-product-lightbox-counter aria-live="polite"></div>',
      '</div>',
      '</div>'
    ].join('');
  };

  var buildDemoProductMarkup = function (product) {
    var gallery = product.gallery && product.gallery.length ? product.gallery : [product.image];
    var mainImage = product.image || gallery[0] || '';
    var label = normalizeDemoLabel(product.badge);
    var displayPrice = ensureTndCurrency(product.price);
    var displayCompare = ensureTndCurrency(product.compare);

    var hasCompare = Boolean(displayCompare);
    var lowerBadge = String(product.badge || '').toLowerCase();
    var demoIsPromo = hasCompare || lowerBadge.indexOf('promo') !== -1;
    var demoIsNew = lowerBadge === '' || lowerBadge.indexOf('nouveau') !== -1;
    var demoBadgesHtml = '<div class="lamassat-product-summary__badges">'
      + (demoIsPromo ? '<span class="lamassat-badge lamassat-badge--promo"><span>PROMO</span><span lang="ar" dir="rtl">&#1578;&#1582;&#1601;&#1610;&#1590;</span></span>' : '')
      + (demoIsNew ? '<span class="lamassat-badge lamassat-badge--new"><span>NOUVEAUT&Eacute;</span><span lang="ar" dir="rtl">&#1580;&#1583;&#1610;&#1583;</span></span>' : '')
      + buildDeliveryBadgeHtml(demoIsPromo)
      + '</div>';
    var demoPriceHtml = '<p class="lamassat-product-summary__price' + (hasCompare ? ' is-sale' : '') + '" data-product-price-wrap><span class="lamassat-product-summary__price-current" data-product-price>' + escapeHtml(displayPrice) + '</span>' + (hasCompare ? '<s class="lamassat-product-summary__price-compare" data-product-compare>' + escapeHtml(displayCompare) + '</s>' : '') + '</p>';
    // TEMP PDP PREVIEW MODE - preview-only Arabic placeholder until product metafields exist.
    var arabicTitle = product.arabicTitle ? escapeHtml(product.arabicTitle) : '&#1602;&#1601;&#1591;&#1575;&#1606; &#1604;&#1610;&#1575;&#1604;';
    var frenchDescription = 'Une pi&egrave;ce raffin&eacute;e pens&eacute;e pour sublimer votre &eacute;l&eacute;gance avec une coupe fluide, des d&eacute;tails d&eacute;licats et une finition soign&eacute;e.';
    var arabicDescription = '&#1602;&#1591;&#1593;&#1577; &#1585;&#1575;&#1602;&#1610;&#1577; &#1589;&#1605;&#1605;&#1578; &#1604;&#1578;&#1605;&#1606;&#1581;&#1603; &#1573;&#1591;&#1604;&#1575;&#1604;&#1577; &#1571;&#1606;&#1610;&#1602;&#1577; &#1576;&#1578;&#1601;&#1575;&#1589;&#1610;&#1604; &#1606;&#1575;&#1593;&#1605;&#1577; &#1608;&#1604;&#1605;&#1587;&#1577; &#1601;&#1575;&#1582;&#1585;&#1577;.';
    var shippingDescription = '<p>Livraison sous 48h maximum partout en Tunisie.</p><p class="lamassat-arabic" lang="ar" dir="rtl">&#1575;&#1604;&#1578;&#1608;&#1589;&#1610;&#1604; &#1601;&#1610; &#1603;&#1575;&#1605;&#1604; &#1578;&#1608;&#1606;&#1587; &#1601;&#1610; &#1605;&#1583;&#1577; &#1571;&#1602;&#1589;&#1575;&#1607;&#1575; 48 &#1587;&#1575;&#1593;&#1577;.</p><p>Pour les retours, contactez-nous afin que notre &eacute;quipe puisse traiter votre demande.</p><p class="lamassat-arabic" lang="ar" dir="rtl">&#1576;&#1575;&#1604;&#1606;&#1587;&#1576;&#1577; &#1604;&#1604;&#1573;&#1585;&#1580;&#1575;&#1593;&#1548; &#1610;&#1585;&#1580;&#1609; &#1575;&#1604;&#1578;&#1608;&#1575;&#1589;&#1604; &#1605;&#1593;&#1606;&#1575; &#1581;&#1578;&#1609; &#1610;&#1578;&#1605;&#1603;&#1606; &#1601;&#1585;&#1610;&#1602;&#1606;&#1575; &#1605;&#1606; &#1605;&#1593;&#1575;&#1604;&#1580;&#1577; &#1591;&#1604;&#1576;&#1603;&#1605;.</p>';
    var cartIcon = '<svg class="lamassat-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 8h13l-1.25 9.25H7.85L6.5 4.75H3.75"></path><path d="M9 8a3 3 0 0 1 6 0"></path><circle cx="9.5" cy="20" r=".75"></circle><circle cx="17" cy="20" r=".75"></circle></svg>';

    return [
      '<section class="lamassat-product-page lamassat-product-page--demo" data-product-section data-demo-product-section>',
      '<div class="lamassat-product-page__shell">',
      '<div class="lamassat-product-gallery" data-product-gallery>',
      '<div class="lamassat-product-gallery__main">',
      mainImage ? '<img src="' + escapeHtml(mainImage) + '" alt="' + escapeHtml(product.title) + '" width="1400" height="1400" loading="eager" data-product-main-image data-media-index="0" data-media-type="image" data-media-src="' + escapeHtml(mainImage) + '" data-media-alt="' + escapeHtml(product.title) + '">' : '<div class="lamassat-product-gallery__placeholder" data-product-main-image aria-label="' + escapeHtml(product.title) + '">Lamassat</div>',
      '</div>',
      '<div class="lamassat-product-gallery__thumbs" aria-label="Images du produit">' + gallery.map(function (image, index) { return buildDemoThumbnailMarkup(image, product, index); }).join('') + '</div>',
      '</div>',
      '<div class="lamassat-product-summary">',
      demoBadgesHtml,
      '<h1 class="lamassat-product-summary__title">' + escapeHtml(product.title) + '</h1>',
      '<p class="lamassat-product-summary__arabic-title" lang="ar" dir="rtl">' + arabicTitle + '</p>',
      demoPriceHtml,
      '<div class="lamassat-product-summary__description rte"><p>' + frenchDescription + '</p></div>',
      '<div class="lamassat-product-summary__arabic-description lamassat-arabic" lang="ar" dir="rtl"><p>' + arabicDescription + '</p></div>',
      '<div class="lamassat-product-form">',
      '<div class="lamassat-product-options">',
      '<fieldset class="lamassat-product-option" data-product-option data-option-position="1">',
      '<legend class="lamassat-product-option__legend"><span>TAILLE</span><span lang="ar" dir="rtl">&#1575;&#1604;&#1605;&#1602;&#1575;&#1587;</span></legend>',
      '<div class="lamassat-product-option__values" role="radiogroup" aria-label="Taille">',
      '<button class="lamassat-product-option__button is-selected" type="button" role="radio" aria-checked="true" data-option-value="T1 (36-40)">T1 (36-40)</button>',
      '<button class="lamassat-product-option__button" type="button" role="radio" aria-checked="false" data-option-value="T2 (42-46)">T2 (42-46)</button>',
      '</div>',
      '</fieldset>',
      '</div>',
      '<a class="lamassat-product-size-guide" href="#LamassatDemoSizeGuide" data-size-guide-link><span>Guide des tailles</span><span lang="ar" dir="rtl">&#1583;&#1604;&#1610;&#1604; &#1575;&#1604;&#1605;&#1602;&#1575;&#1587;&#1575;&#1578;</span></a>',
      '<div class="lamassat-product-purchase">',
      '<label class="lamassat-product-quantity" for="LamassatDemoQuantity"><span>QUANTIT&Eacute;</span><span lang="ar" dir="rtl">&#1575;&#1604;&#1603;&#1605;&#1610;&#1577;</span></label>',
      '<div class="lamassat-product-quantity__control" data-quantity-control><button type="button" aria-label="Diminuer la quantit&eacute;" data-quantity-minus>&minus;</button><input id="LamassatDemoQuantity" type="number" value="1" min="1" inputmode="numeric" data-quantity-input><button type="button" aria-label="Augmenter la quantit&eacute;" data-quantity-plus>+</button></div>',
      '</div>',
      '<div class="lamassat-product-actions">',
      '<button class="lamassat-product-actions__add" type="button" data-add-to-cart data-demo-preview-action data-add-label="AJOUTER AU PANIER" data-sold-out-label="&Eacute;PUIS&Eacute;">' + cartIcon + '<span>AJOUTER AU PANIER</span></button>',
      '<button class="lamassat-product-actions__buy" type="button" data-buy-now data-demo-preview-action>ACHETER MAINTENANT</button>',
      '</div>',
      '<p class="lamassat-product-preview-note" data-demo-preview-note>Aper&ccedil;u seulement, aucune variante Shopify n&apos;est ajout&eacute;e au panier.</p>',
      '</div>',
      '<script type="application/json" data-product-variants>[{"id":900001,"available":true,"options":["T1 (36-40)"],"price":0,"price_formatted":' + JSON.stringify(displayPrice || '') + ',"compare_at_price_formatted":' + JSON.stringify(displayCompare || '') + ',"on_sale":' + (hasCompare ? 'true' : 'false') + ',"featured_media_id":null},{"id":900002,"available":true,"options":["T2 (42-46)"],"price":0,"price_formatted":' + JSON.stringify(displayPrice || '') + ',"compare_at_price_formatted":' + JSON.stringify(displayCompare || '') + ',"on_sale":' + (hasCompare ? 'true' : 'false') + ',"featured_media_id":null}]</' + 'script>',
      '</div>',
      '</div>',
      buildProductLightboxMarkup(),
      '<div class="lamassat-product-accordions" data-product-accordions>',
      buildDemoAccordion('LamassatDemoDetails', 'D&Eacute;TAILS DU PRODUIT', '&#1578;&#1601;&#1575;&#1589;&#1610;&#1604; &#1575;&#1604;&#1605;&#1606;&#1578;&#1580;', '<div class="rte"><p>' + frenchDescription + '</p><p class="lamassat-arabic" lang="ar" dir="rtl">' + arabicDescription + '</p></div>', 'dress'),
      buildDemoAccordion('LamassatDemoSizeGuide', 'GUIDE DES TAILLES', '&#1583;&#1604;&#1610;&#1604; &#1575;&#1604;&#1605;&#1602;&#1575;&#1587;&#1575;&#1578;', '<p>Choisissez la taille qui correspond le mieux &agrave; vos mesures. Cette section est temporaire pour l&apos;aper&ccedil;u visuel.</p><p class="lamassat-arabic" lang="ar" dir="rtl">&#1575;&#1582;&#1578;&#1575;&#1585;&#1610; &#1575;&#1604;&#1605;&#1602;&#1575;&#1587; &#1575;&#1604;&#1571;&#1606;&#1587;&#1576; &#1604;&#1602;&#1610;&#1575;&#1587;&#1575;&#1578;&#1603;.</p>', 'ruler'),
      buildDemoAccordion('LamassatDemoShipping', 'LIVRAISON &amp; RETOURS', '&#1575;&#1604;&#1588;&#1581;&#1606; &#1608; &#1575;&#1604;&#1573;&#1585;&#1580;&#1575;&#1593;', shippingDescription, 'truck'),
      '</div>',
      '</section>'
    ].join('');
  };

  var getDemoAccordionIcon = function (icon) {
    if (icon === 'ruler') {
      return '<svg viewBox="0 0 32 32" focusable="false"><path d="M5 22 22 5l5 5-17 17-5-5Z"></path><path d="m9 18 2 2"></path><path d="m13 14 2 2"></path><path d="m17 10 2 2"></path></svg>';
    }

    if (icon === 'truck') {
      return '<svg viewBox="0 0 32 32" focusable="false"><path d="M5 9h15v12H5z"></path><path d="M20 13h4l3 3v5h-7z"></path><circle cx="10" cy="23" r="2"></circle><circle cx="24" cy="23" r="2"></circle></svg>';
    }

    return '<svg viewBox="0 0 32 32" focusable="false"><path d="M13 5h6l2.5 5.5L19 13v14H7V13l-2.5-2.5L7 5h6a3 3 0 0 0 6 0"></path></svg>';
  };

  var buildDemoAccordion = function (id, title, arabicTitle, content, icon) {
    return [
      '<div class="lamassat-product-accordion" id="' + id + '">',
      '<button class="lamassat-product-accordion__trigger" type="button" aria-expanded="false" aria-controls="' + id + 'Panel" data-product-accordion-trigger>',
      '<span class="lamassat-product-accordion__icon" aria-hidden="true">' + getDemoAccordionIcon(icon) + '</span>',
      '<span class="lamassat-product-accordion__text"><span>' + title + '</span><span lang="ar" dir="rtl">' + arabicTitle + '</span></span>',
      '<span class="lamassat-product-accordion__plus" aria-hidden="true"></span>',
      '</button>',
      '<div class="lamassat-product-accordion__panel" id="' + id + 'Panel" data-product-accordion-panel>' + content + '</div>',
      '</div>'
    ].join('');
  };

  var initDemoPreviewActions = function (section) {
    var productData = readSessionJson(demoProductStorageKey) || getDemoProductFromCard(document.querySelector('[data-demo-product]'));

    Array.prototype.slice.call(section.querySelectorAll('[data-demo-preview-action]')).forEach(function (button) {
      button.addEventListener('click', function () {
        if (!productData) {
          return;
        }

        var selectedSize = section.querySelector('.lamassat-product-option__button.is-selected');
        var quantityInput = section.querySelector('[data-quantity-input]');
        var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

        LamassatCart.add({
          isDemo: true,
          title: productData.title,
          variant: selectedSize ? selectedSize.getAttribute('data-option-value') : '',
          priceMillimes: LamassatCart.parseDemoPrice(productData.price),
          image: productData.image || (productData.gallery && productData.gallery[0]) || '',
          url: window.location.pathname + window.location.search,
          quantity: quantity
        });
      });
    });
  };

  var hasQueryParam = function (name) {
    var query = window.location.search ? window.location.search.slice(1).split('&') : [];

    return query.some(function (part) {
      return decodeURIComponent(part.split('=')[0] || '') === name;
    });
  };

  var initDemoPdpPreview = function () {
    initDemoProductLinks();

    if (!hasQueryParam('pdp-preview')) {
      return;
    }

    var main = document.getElementById('MainContent');
    if (!main) {
      return;
    }

    var productData = readSessionJson(demoProductStorageKey) || getDemoProductFromCard(document.querySelector('[data-demo-product]'));
    if (!productData) {
      return;
    }

    document.body.classList.add('lamassat-template-product', 'lamassat-demo-pdp-active');
    main.innerHTML = buildDemoProductMarkup(productData);
    window.scrollTo(0, 0);

    var demoSection = main.querySelector('[data-demo-product-section]');
    if (demoSection) {
      initDemoPreviewActions(demoSection);
    }
  };

  var initProductPage = function () {
    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      var variantsNode = section.querySelector('[data-product-variants]');
      var variants = [];
      var form = section.querySelector('[data-product-form]');
      var variantInput = section.querySelector('[data-variant-id]');
      var returnToInput = section.querySelector('[data-return-to]');
      var priceNode = section.querySelector('[data-product-price]');
      var compareNode = section.querySelector('[data-product-compare]');
      var priceWrap = section.querySelector('[data-product-price-wrap]');
      var deliveryBadge = section.querySelector('[data-lamassat-delivery-badge]');
      var deliveryPromotionLocked = deliveryBadge && deliveryBadge.getAttribute('data-delivery-promo-locked') === 'true';
      var addButton = section.querySelector('[data-add-to-cart]');
      var buyButton = section.querySelector('[data-buy-now]');
      var stockStatus = section.querySelector('[data-product-stock-status]');
      var stockMessage = section.querySelector('[data-product-stock-message]');
      var optionGroups = Array.prototype.slice.call(section.querySelectorAll('[data-product-option]'));
      var optionButtons = Array.prototype.slice.call(section.querySelectorAll('[data-option-value]'));
      var quantityInput = section.querySelector('[data-quantity-input]');
      var minusButton = section.querySelector('[data-quantity-minus]');
      var plusButton = section.querySelector('[data-quantity-plus]');
      var galleryMain = section.querySelector('.lamassat-product-gallery__main');
      var mainImage = section.querySelector('[data-product-main-image]');
      var mediaPanes = Array.prototype.slice.call(section.querySelectorAll('[data-product-media]'));
      var thumbnails = Array.prototype.slice.call(section.querySelectorAll('[data-product-thumbnail]'));
      var sizeGuideModal = section.querySelector('[data-size-guide-modal]');
      var sizeGuideDialog = sizeGuideModal ? sizeGuideModal.querySelector('[data-size-guide-dialog]') : null;
      var sizeGuideOpeners = Array.prototype.slice.call(section.querySelectorAll('[data-size-guide-open]'));
      var sizeGuideCloseButtons = sizeGuideModal ? Array.prototype.slice.call(sizeGuideModal.querySelectorAll('[data-size-guide-close]')) : [];
      var lastSizeGuideTrigger = null;
      var sizeGuideCloseTimer = null;
      var checkoutRequested = false;
      var productLightbox = section.querySelector('[data-product-lightbox]');
      var productLightboxDialog = productLightbox ? productLightbox.querySelector('[data-product-lightbox-dialog]') : null;
      var productLightboxMedia = productLightbox ? productLightbox.querySelector('[data-product-lightbox-media]') : null;
      var productLightboxCounter = productLightbox ? productLightbox.querySelector('[data-product-lightbox-counter]') : null;
      var productLightboxStage = productLightbox ? productLightbox.querySelector('[data-product-lightbox-stage]') : null;
      var productLightboxPrev = productLightbox ? productLightbox.querySelector('[data-product-lightbox-prev]') : null;
      var productLightboxNext = productLightbox ? productLightbox.querySelector('[data-product-lightbox-next]') : null;
      var productLightboxCloseButtons = productLightbox ? Array.prototype.slice.call(productLightbox.querySelectorAll('[data-product-lightbox-close]')) : [];
      var productLightboxItems = [];
      var productLightboxIndex = 0;
      var productLightboxCloseTimer = null;
      var productLightboxImageCache = {};
      var lastProductLightboxTrigger = null;
      var productLightboxTouch = { startX: 0, startY: 0, moved: false, mode: '' };
      var productLightboxZoom = {
        scale: 1,
        min: 1,
        max: 3,
        translateX: 0,
        translateY: 0,
        startScale: 1,
        startDistance: 0,
        startX: 0,
        startY: 0,
        startTranslateX: 0,
        startTranslateY: 0,
        lastTapTime: 0,
        lastTapX: 0,
        lastTapY: 0
      };

      if (variantsNode) {
        try {
          variants = JSON.parse(variantsNode.textContent);
        } catch (error) {
          variants = [];
        }
      }

      var getSelectedOptions = function () {
        var options = [];

        optionGroups.forEach(function (group) {
          var position = Number(group.getAttribute('data-option-position')) - 1;
          var selected = group.querySelector('[data-option-value][aria-checked="true"]');
          options[position] = selected ? selected.getAttribute('data-option-value') : null;
        });

        return options;
      };

      var getVariantByOptions = function (options) {
        if (!variants.length) {
          return null;
        }

        if (!optionGroups.length) {
          if (variantInput && variantInput.value) {
            var currentId = Number(variantInput.value);
            var currentVariant = variants.filter(function (variant) {
              return Number(variant.id) === currentId;
            })[0];

            if (currentVariant) {
              return currentVariant;
            }
          }

          return variants[0];
        }

        return variants.filter(function (variant) {
          for (var index = 0; index < optionGroups.length; index += 1) {
            if (variant.options[index] !== options[index]) {
              return false;
            }
          }

          return true;
        })[0] || null;
      };

      var setAddButtonState = function (variant) {
        var available = isLamassatVariantAvailable(variant);

        if (addButton) {
          addButton.disabled = !available;
          setStockButtonLabel(addButton, '[data-add-to-cart-label]', available);
        }

        if (buyButton) {
          buyButton.disabled = !available;
          setStockButtonLabel(buyButton, '[data-buy-now-label]', available);
        }

        if (variantInput) {
          variantInput.disabled = !available;
        }

        if (stockStatus) {
          stockStatus.hidden = available;
          stockStatus.classList.toggle('is-visible', !available);
        }

        if (stockMessage && available) {
          stockMessage.hidden = true;
        }
      };

      var showProductStockMessage = function () {
        if (!stockMessage) {
          return;
        }

        stockMessage.hidden = false;
      };

      var pauseMediaPane = function (pane) {
        if (!pane) {
          return;
        }

        Array.prototype.slice.call(pane.querySelectorAll('video')).forEach(function (video) {
          try {
            video.pause();
            video.currentTime = 0;
          } catch (error) {
            // Some browsers block seeking until media metadata is ready.
          }
        });

        Array.prototype.slice.call(pane.querySelectorAll('iframe')).forEach(function (iframe) {
          var src = iframe.getAttribute('src');
          if (src) {
            iframe.setAttribute('src', src);
          }
        });
      };

      var setThumbnailState = function (activeThumbnail) {
        thumbnails.forEach(function (item) {
          var active = item === activeThumbnail;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      var preloadedGalleryImages = [];

      var setMediaPaneLoadingState = function (pane) {
        var image = pane ? pane.querySelector('img[data-product-main-image]') : null;
        if (!pane || !image) {
          return;
        }

        var clearLoading = function () {
          pane.classList.remove('is-loading');
          image.removeEventListener('load', clearLoading);
          image.removeEventListener('error', clearLoading);
        };

        if (image.complete && image.naturalWidth > 0) {
          clearLoading();
          return;
        }

        pane.classList.add('is-loading');
        image.addEventListener('load', clearLoading, { once: true });
        image.addEventListener('error', clearLoading, { once: true });
      };

      var preloadGalleryImages = function () {
        if (!mediaPanes.length) {
          return;
        }

        var preloadImages = function () {
          mediaPanes.forEach(function (pane) {
            var image = pane.querySelector('img[data-product-main-image]');
            if (!image || (image.complete && image.naturalWidth > 0)) {
              return;
            }

            var preload = new Image();
            if (image.sizes) {
              preload.sizes = image.sizes;
            }

            if (image.srcset) {
              preload.srcset = image.srcset;
            }

            preload.decoding = 'async';
            preload.src = image.currentSrc || image.src;
            preloadedGalleryImages.push(preload);

            if (preload.decode) {
              preload.decode().catch(function () {});
            }
          });
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preloadImages, { timeout: 1400 });
        } else {
          window.setTimeout(preloadImages, 180);
        }
      };

      var setActiveMediaPane = function (mediaId) {
        if (!mediaId) {
          return false;
        }

        if (!mediaPanes.length) {
          return false;
        }

        var activePane = mediaPanes.filter(function (pane) {
          return Number(pane.getAttribute('data-media-id')) === Number(mediaId);
        })[0];

        if (!activePane) {
          return false;
        }

        mediaPanes.forEach(function (pane) {
          var active = pane === activePane;
          if (!active) {
            pauseMediaPane(pane);
          }

          pane.hidden = !active;
          pane.classList.toggle('is-active', active);
          pane.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        setMediaPaneLoadingState(activePane);

        return true;
      };

      var setActiveThumbnail = function (mediaId) {
        if (!mediaId) {
          return;
        }

        if (!thumbnails.length) {
          return;
        }

        var activeThumbnail = thumbnails.filter(function (thumbnail) {
          return Number(thumbnail.getAttribute('data-media-id')) === Number(mediaId);
        })[0];

        if (activeThumbnail) {
          updateMainImage(activeThumbnail);
        }
      };

      var updateOptionAvailability = function (selectedOptions) {
        optionGroups.forEach(function (group) {
          var position = Number(group.getAttribute('data-option-position')) - 1;
          var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));

          buttons.forEach(function (button) {
            var value = button.getAttribute('data-option-value');
            var hasAvailableVariant = variants.some(function (variant) {
              if (!isLamassatVariantAvailable(variant)) {
                return false;
              }

              for (var index = 0; index < optionGroups.length; index += 1) {
                var targetValue = index === position ? value : selectedOptions[index];
                if (targetValue && variant.options[index] !== targetValue) {
                  return false;
                }
              }

              return true;
            });

            button.disabled = !hasAvailableVariant;
            button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          });
        });
      };

      var updateVariant = function () {
        var selectedOptions = getSelectedOptions();
        var variant = getVariantByOptions(selectedOptions);

        if (!variant) {
          setAddButtonState(null);
          return;
        }

        if (variantInput) {
          variantInput.value = variant.id;
        }

        if (priceNode && variant.price_formatted) {
          priceNode.textContent = ensureTndCurrency(variant.price_formatted);
        }

        if (compareNode && priceWrap) {
          if (variant.on_sale && variant.compare_at_price_formatted) {
            compareNode.textContent = ensureTndCurrency(variant.compare_at_price_formatted);
            compareNode.hidden = false;
            priceWrap.classList.add('is-sale');
          } else {
            compareNode.hidden = true;
            priceWrap.classList.remove('is-sale');
          }
        }

        setDeliveryBadgeState(deliveryBadge, isPaidDelivery({ deliveryPromotionLocked: deliveryPromotionLocked }, variant));

        setAddButtonState(variant);
        updateOptionAvailability(selectedOptions);
        setActiveThumbnail(variant.featured_media_id);

        if (window.history && window.history.replaceState && window.URL) {
          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', nextUrl.toString());
        }
      };

      var updateSelectedButton = function (button) {
        var group = button.closest('[data-product-option]');
        if (!group) {
          return;
        }

        Array.prototype.slice.call(group.querySelectorAll('[data-option-value]')).forEach(function (groupButton) {
          var selected = groupButton === button;
          groupButton.classList.toggle('is-selected', selected);
          groupButton.setAttribute('aria-checked', selected ? 'true' : 'false');
        });

        updateVariant();
      };

      var updateQuantity = function (delta) {
        if (!quantityInput) {
          return;
        }

        var currentValue = Number(quantityInput.value) || 1;
        var nextValue = Math.max(1, currentValue + delta);
        quantityInput.value = String(nextValue);
      };

      var normalizeQuantity = function () {
        if (!quantityInput) {
          return;
        }

        var value = Number(quantityInput.value) || 1;
        quantityInput.value = String(Math.max(1, Math.floor(value)));
      };

      var updateMainImage = function (thumbnail) {
        if (!thumbnail) {
          return;
        }

        var mediaId = thumbnail.getAttribute('data-media-id');
        if (setActiveMediaPane(mediaId)) {
          setThumbnailState(thumbnail);
          return;
        }

        if (!mainImage) {
          return;
        }

        if (mainImage.tagName !== 'IMG') {
          return;
        }

        mainImage.src = thumbnail.getAttribute('data-full-src');
        mainImage.alt = thumbnail.getAttribute('data-full-alt') || '';

        if (thumbnail.getAttribute('data-full-width')) {
          mainImage.width = Number(thumbnail.getAttribute('data-full-width'));
        }

        if (thumbnail.getAttribute('data-full-height')) {
          mainImage.height = Number(thumbnail.getAttribute('data-full-height'));
        }

        setThumbnailState(thumbnail);
      };

      var isProductLightboxSupportedType = function (type) {
        return type === 'image' || type === 'video' || type === 'external_video';
      };

      var getProductLightboxImageSizes = function () {
        return '(max-width: 749px) calc(100vw - 24px), min(92vw, 1400px)';
      };

      var getWrappedProductLightboxIndex = function (index) {
        if (!productLightboxItems.length) {
          return 0;
        }

        return (index + productLightboxItems.length) % productLightboxItems.length;
      };

      var getProductLightboxItems = function () {
        var items = [];

        if (mediaPanes.length) {
          mediaPanes.forEach(function (pane, paneIndex) {
            var mediaType = pane.getAttribute('data-media-type') || 'image';
            if (!isProductLightboxSupportedType(mediaType)) {
              return;
            }

            var image = pane.querySelector('img[data-product-main-image]');
            var mediaNode = pane.querySelector('video, iframe');
            var src = pane.getAttribute('data-media-src') || (image ? (image.currentSrc || image.src) : '');

            if (mediaType === 'image' && !src) {
              return;
            }

            if (mediaType !== 'image' && !mediaNode) {
              return;
            }

            items.push({
              type: mediaType,
              pane: pane,
              mediaId: pane.getAttribute('data-media-id') || '',
              mediaIndex: Number(pane.getAttribute('data-media-index') || paneIndex),
              src: src,
              srcset: pane.getAttribute('data-media-srcset') || '',
              poster: pane.getAttribute('data-media-poster') || '',
              alt: pane.getAttribute('data-media-alt') || (image ? image.alt : '')
            });
          });

          return items;
        }

        if (thumbnails.length) {
          thumbnails.forEach(function (thumbnail, thumbnailIndex) {
            var mediaType = thumbnail.getAttribute('data-media-type') || 'image';
            var src = thumbnail.getAttribute('data-full-src');
            if (mediaType !== 'image' || !src) {
              return;
            }

            items.push({
              type: 'image',
              mediaId: thumbnail.getAttribute('data-media-id') || '',
              mediaIndex: Number(thumbnail.getAttribute('data-media-index') || thumbnailIndex),
              src: src,
              srcset: thumbnail.getAttribute('data-media-srcset') || '',
              poster: src,
              alt: thumbnail.getAttribute('data-full-alt') || ''
            });
          });

          if (items.length) {
            return items;
          }
        }

        if (mainImage && mainImage.tagName === 'IMG') {
          var imageSrc = mainImage.getAttribute('data-media-src') || mainImage.currentSrc || mainImage.src;
          if (imageSrc) {
            items.push({
              type: 'image',
              mediaId: mainImage.getAttribute('data-media-id') || '',
              mediaIndex: Number(mainImage.getAttribute('data-media-index') || 0),
              src: imageSrc,
              srcset: mainImage.getAttribute('data-media-srcset') || '',
              poster: mainImage.getAttribute('data-media-poster') || imageSrc,
              alt: mainImage.getAttribute('data-media-alt') || mainImage.alt || ''
            });
          }
        }

        return items;
      };

      var getCurrentProductLightboxIndex = function (trigger) {
        if (!productLightboxItems.length) {
          return 0;
        }

        var activeMediaId = '';
        var activePane = mediaPanes.filter(function (pane) {
          return pane.classList.contains('is-active') && isProductLightboxSupportedType(pane.getAttribute('data-media-type'));
        })[0];

        if (activePane) {
          activeMediaId = activePane.getAttribute('data-media-id') || '';
        }

        if (!activeMediaId && thumbnails.length) {
          var activeThumbnail = thumbnails.filter(function (thumbnail) {
            return thumbnail.classList.contains('is-active');
          })[0];
          activeMediaId = activeThumbnail ? (activeThumbnail.getAttribute('data-media-id') || '') : '';
        }

        if (activeMediaId) {
          for (var mediaIndex = 0; mediaIndex < productLightboxItems.length; mediaIndex += 1) {
            if (String(productLightboxItems[mediaIndex].mediaId) === String(activeMediaId)) {
              return mediaIndex;
            }
          }
        }

        var activeSrc = '';
        if (trigger && trigger.tagName === 'IMG') {
          activeSrc = trigger.getAttribute('data-media-src') || trigger.currentSrc || trigger.src;
        } else if (mainImage && mainImage.tagName === 'IMG') {
          activeSrc = mainImage.getAttribute('data-media-src') || mainImage.currentSrc || mainImage.src;
        }

        if (activeSrc) {
          for (var srcIndex = 0; srcIndex < productLightboxItems.length; srcIndex += 1) {
            if (productLightboxItems[srcIndex].src === activeSrc) {
              return srcIndex;
            }
          }
        }

        return 0;
      };

      var pauseProductLightboxMedia = function () {
        if (!productLightboxMedia) {
          return;
        }

        Array.prototype.slice.call(productLightboxMedia.querySelectorAll('video')).forEach(function (video) {
          try {
            video.pause();
          } catch (error) {
            // Media may not be ready yet.
          }
        });

        Array.prototype.slice.call(productLightboxMedia.querySelectorAll('iframe')).forEach(function (iframe) {
          var src = iframe.getAttribute('src');
          if (src) {
            iframe.setAttribute('src', src);
          }
        });
      };

      var preloadProductLightboxImage = function (index) {
        if (!productLightboxItems.length) {
          return;
        }

        var item = productLightboxItems[getWrappedProductLightboxIndex(index)];
        if (!item || item.type !== 'image' || !item.src) {
          return;
        }

        var key = item.srcset || item.src;
        if (productLightboxImageCache[key]) {
          return;
        }

        var preload = new Image();
        preload.decoding = 'async';
        preload.loading = 'eager';
        if (item.srcset) {
          preload.srcset = item.srcset;
          preload.sizes = getProductLightboxImageSizes();
        }
        preload.src = item.src;
        productLightboxImageCache[key] = preload;

        if (preload.decode) {
          preload.decode().catch(function () {});
        }
      };

      var preloadProductLightboxNeighbors = function () {
        preloadProductLightboxImage(productLightboxIndex);
        preloadProductLightboxImage(productLightboxIndex - 1);
        preloadProductLightboxImage(productLightboxIndex + 1);
        preloadProductLightboxImage(productLightboxIndex + 2);
      };

      var getProductLightboxImage = function () {
        return productLightboxMedia ? productLightboxMedia.querySelector('.lamassat-product-lightbox__image') : null;
      };

      var clampProductLightboxPan = function () {
        var image = getProductLightboxImage();
        if (!image || !productLightboxMedia || productLightboxZoom.scale <= 1) {
          productLightboxZoom.translateX = 0;
          productLightboxZoom.translateY = 0;
          return;
        }

        var maxX = Math.max(0, ((image.clientWidth || 0) * productLightboxZoom.scale - productLightboxMedia.clientWidth) / 2);
        var maxY = Math.max(0, ((image.clientHeight || 0) * productLightboxZoom.scale - productLightboxMedia.clientHeight) / 2);
        productLightboxZoom.translateX = Math.max(-maxX, Math.min(maxX, productLightboxZoom.translateX));
        productLightboxZoom.translateY = Math.max(-maxY, Math.min(maxY, productLightboxZoom.translateY));
      };

      var applyProductLightboxZoom = function () {
        var image = getProductLightboxImage();
        if (!image) {
          return;
        }

        clampProductLightboxPan();
        image.style.transform = 'translate3d(' + productLightboxZoom.translateX + 'px, ' + productLightboxZoom.translateY + 'px, 0) scale(' + productLightboxZoom.scale + ')';
        productLightboxMedia.classList.toggle('is-zoomed', productLightboxZoom.scale > 1.01);
      };

      var setProductLightboxZoom = function (scale, translateX, translateY) {
        productLightboxZoom.scale = Math.max(productLightboxZoom.min, Math.min(productLightboxZoom.max, scale));
        productLightboxZoom.translateX = translateX || 0;
        productLightboxZoom.translateY = translateY || 0;
        if (productLightboxZoom.scale <= 1.01) {
          productLightboxZoom.scale = 1;
          productLightboxZoom.translateX = 0;
          productLightboxZoom.translateY = 0;
        }
        applyProductLightboxZoom();
      };

      var resetProductLightboxZoom = function () {
        productLightboxZoom.scale = 1;
        productLightboxZoom.translateX = 0;
        productLightboxZoom.translateY = 0;
        productLightboxTouch.mode = '';
        if (productLightboxMedia) {
          productLightboxMedia.classList.remove('is-zoomed');
        }

        var image = getProductLightboxImage();
        if (image) {
          image.style.transform = '';
        }
      };

      var getProductLightboxTouchDistance = function (touches) {
        if (!touches || touches.length < 2) {
          return 0;
        }

        var deltaX = touches[0].clientX - touches[1].clientX;
        var deltaY = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      };

      var renderProductLightboxMedia = function () {
        if (!productLightboxMedia) {
          return;
        }

        var item = productLightboxItems[productLightboxIndex];
        pauseProductLightboxMedia();
        productLightboxMedia.innerHTML = '';
        productLightboxMedia.classList.remove('is-image', 'is-video', 'is-external-video', 'is-zoomed');
        resetProductLightboxZoom();

        if (!item) {
          return;
        }

        if (item.type === 'image') {
          var image = document.createElement('img');
          image.className = 'lamassat-product-lightbox__image';
          image.alt = item.alt || '';
          image.decoding = 'async';
          image.loading = 'eager';
          image.draggable = false;
          if (item.srcset) {
            image.srcset = item.srcset;
            image.sizes = getProductLightboxImageSizes();
          }
          image.src = item.src;
          productLightboxMedia.classList.add('is-image');
          productLightboxMedia.appendChild(image);
        } else {
          var sourceMedia = item.pane ? item.pane.querySelector('video, iframe') : null;
          if (sourceMedia) {
            var clonedMedia = sourceMedia.cloneNode(true);
            if (item.type === 'video') {
              clonedMedia.className = 'lamassat-product-lightbox__video';
              clonedMedia.controls = true;
              clonedMedia.preload = 'metadata';
              if (item.poster && !clonedMedia.getAttribute('poster')) {
                clonedMedia.setAttribute('poster', item.poster);
              }
              productLightboxMedia.classList.add('is-video');
            } else {
              clonedMedia.className = 'lamassat-product-lightbox__external-video';
              clonedMedia.setAttribute('allowfullscreen', 'allowfullscreen');
              productLightboxMedia.classList.add('is-external-video');
            }
            productLightboxMedia.appendChild(clonedMedia);
          }
        }

        if (productLightboxCounter) {
          productLightboxCounter.textContent = (productLightboxIndex + 1) + ' / ' + productLightboxItems.length;
        }

        var singleItem = productLightboxItems.length <= 1;
        if (productLightboxPrev) {
          productLightboxPrev.hidden = singleItem;
        }

        if (productLightboxNext) {
          productLightboxNext.hidden = singleItem;
        }

        preloadProductLightboxNeighbors();
      };

      var showProductLightboxItem = function (delta) {
        if (productLightboxItems.length <= 1 || productLightboxZoom.scale > 1.01) {
          return;
        }

        productLightboxIndex = getWrappedProductLightboxIndex(productLightboxIndex + delta);
        renderProductLightboxMedia();
      };

      var openProductLightbox = function (trigger) {
        if (!productLightbox || !productLightboxMedia) {
          return;
        }

        productLightboxItems = getProductLightboxItems();
        if (!productLightboxItems.length) {
          return;
        }

        lastProductLightboxTrigger = trigger || document.activeElement;
        productLightboxIndex = getCurrentProductLightboxIndex(trigger);
        window.clearTimeout(productLightboxCloseTimer);
        preloadProductLightboxNeighbors();
        renderProductLightboxMedia();
        productLightbox.hidden = false;
        productLightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('lamassat-product-lightbox-open');
        document.body.classList.add('lamassat-product-lightbox-open');

        window.requestAnimationFrame(function () {
          productLightbox.classList.add('is-open');
        });

        document.addEventListener('keydown', handleProductLightboxKeydown);

        window.setTimeout(function () {
          var focusTarget = productLightbox.querySelector('.lamassat-product-lightbox__close') || productLightboxDialog;
          if (focusTarget && focusTarget.focus) {
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (error) {
              focusTarget.focus();
            }
          }
        }, 60);
      };

      var closeProductLightbox = function () {
        if (!productLightbox || productLightbox.hidden) {
          return;
        }

        pauseProductLightboxMedia();
        resetProductLightboxZoom();
        productLightbox.classList.remove('is-open');
        productLightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('lamassat-product-lightbox-open');
        document.body.classList.remove('lamassat-product-lightbox-open');
        document.removeEventListener('keydown', handleProductLightboxKeydown);
        window.clearTimeout(productLightboxCloseTimer);

        productLightboxCloseTimer = window.setTimeout(function () {
          if (!productLightbox.classList.contains('is-open')) {
            productLightbox.hidden = true;
            if (productLightboxMedia) {
              productLightboxMedia.innerHTML = '';
              productLightboxMedia.classList.remove('is-image', 'is-video', 'is-external-video', 'is-zoomed');
            }
          }
        }, 180);

        if (lastProductLightboxTrigger && document.contains(lastProductLightboxTrigger) && lastProductLightboxTrigger.focus) {
          try {
            lastProductLightboxTrigger.focus({ preventScroll: true });
          } catch (error) {
            lastProductLightboxTrigger.focus();
          }
        }
      };

      function handleProductLightboxKeydown(event) {
        if (!productLightbox || productLightbox.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeProductLightbox();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showProductLightboxItem(-1);
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showProductLightboxItem(1);
        }
      }

      var toggleAccordion = function (trigger, forceOpen) {
        var item = trigger.closest('.lamassat-product-accordion');
        var panel = item ? item.querySelector('[data-product-accordion-panel]') : null;
        if (!item || !panel) {
          return;
        }

        var isOpen = typeof forceOpen === 'boolean' ? forceOpen : trigger.getAttribute('aria-expanded') !== 'true';
        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        if (isOpen) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          window.requestAnimationFrame(function () {
            panel.style.maxHeight = '0px';
          });
        }
      };

      var closeSizeGuideModal = function () {
        if (!sizeGuideModal || sizeGuideModal.hidden) {
          return;
        }

        sizeGuideModal.classList.remove('is-open');
        document.body.classList.remove('lamassat-size-guide-modal-open');
        document.removeEventListener('keydown', handleSizeGuideKeydown);

        sizeGuideCloseTimer = window.setTimeout(function () {
          if (!sizeGuideModal.classList.contains('is-open')) {
            sizeGuideModal.hidden = true;
          }
        }, 180);

        if (lastSizeGuideTrigger && document.contains(lastSizeGuideTrigger)) {
          try {
            lastSizeGuideTrigger.focus({ preventScroll: true });
          } catch (error) {
            lastSizeGuideTrigger.focus();
          }
        }
      };

      var openSizeGuideModal = function (trigger) {
        if (!sizeGuideModal) {
          return;
        }

        lastSizeGuideTrigger = trigger || document.activeElement;
        window.clearTimeout(sizeGuideCloseTimer);
        sizeGuideModal.hidden = false;
        document.body.classList.add('lamassat-size-guide-modal-open');

        window.requestAnimationFrame(function () {
          sizeGuideModal.classList.add('is-open');
        });

        document.addEventListener('keydown', handleSizeGuideKeydown);

        if (sizeGuideDialog) {
          window.setTimeout(function () {
            try {
              sizeGuideDialog.focus({ preventScroll: true });
            } catch (error) {
              sizeGuideDialog.focus();
            }
          }, 60);
        }
      };

      function handleSizeGuideKeydown(event) {
        if (event.key === 'Escape') {
          closeSizeGuideModal();
        }
      }

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!button.disabled) {
            updateSelectedButton(button);
          }
        });
      });

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          updateMainImage(thumbnail);
        });
      });

      if (galleryMain && productLightbox) {
        galleryMain.addEventListener('click', function (event) {
          var image = event.target.closest ? event.target.closest('img[data-product-main-image]') : null;
          if (!image || !galleryMain.contains(image)) {
            return;
          }

          var pane = image.closest ? image.closest('[data-product-media]') : null;
          if (pane && (pane.hidden || pane.getAttribute('data-media-type') !== 'image')) {
            return;
          }

          event.preventDefault();
          openProductLightbox(image);
        });
      }

      if (productLightbox) {
        productLightboxCloseButtons.forEach(function (button) {
          button.addEventListener('click', closeProductLightbox);
        });

        if (productLightboxPrev) {
          productLightboxPrev.addEventListener('click', function () {
            showProductLightboxItem(-1);
          });
        }

        if (productLightboxNext) {
          productLightboxNext.addEventListener('click', function () {
            showProductLightboxItem(1);
          });
        }

        if (productLightboxStage) {
          productLightboxStage.addEventListener('click', function (event) {
            if (productLightboxTouch.moved) {
              event.preventDefault();
              productLightboxTouch.moved = false;
              return;
            }

            if (event.target === productLightboxStage || event.target === productLightboxMedia) {
              closeProductLightbox();
            }
          });

          productLightboxStage.addEventListener('touchstart', function (event) {
            if (!event.touches || !event.touches.length) {
              return;
            }

            productLightboxTouch.moved = false;
            productLightboxTouch.startX = event.touches[0].clientX;
            productLightboxTouch.startY = event.touches[0].clientY;

            if (event.touches.length > 1 && productLightboxItems[productLightboxIndex] && productLightboxItems[productLightboxIndex].type === 'image') {
              productLightboxTouch.mode = 'pinch';
              productLightboxTouch.moved = true;
              productLightboxZoom.startDistance = getProductLightboxTouchDistance(event.touches);
              productLightboxZoom.startScale = productLightboxZoom.scale;
              productLightboxZoom.startTranslateX = productLightboxZoom.translateX;
              productLightboxZoom.startTranslateY = productLightboxZoom.translateY;
              return;
            }

            if (productLightboxZoom.scale > 1.01) {
              productLightboxTouch.mode = 'pan';
              productLightboxZoom.startX = event.touches[0].clientX;
              productLightboxZoom.startY = event.touches[0].clientY;
              productLightboxZoom.startTranslateX = productLightboxZoom.translateX;
              productLightboxZoom.startTranslateY = productLightboxZoom.translateY;
              return;
            }

            productLightboxTouch.mode = 'swipe';
          }, { passive: true });

          productLightboxStage.addEventListener('touchmove', function (event) {
            if (!event.touches || !event.touches.length) {
              return;
            }

            if (productLightboxTouch.mode === 'pinch' && event.touches.length > 1) {
              event.preventDefault();
              var nextScale = productLightboxZoom.startScale * (getProductLightboxTouchDistance(event.touches) / Math.max(productLightboxZoom.startDistance, 1));
              setProductLightboxZoom(nextScale, productLightboxZoom.startTranslateX, productLightboxZoom.startTranslateY);
              productLightboxTouch.moved = true;
              return;
            }

            if (productLightboxTouch.mode === 'pan' && productLightboxZoom.scale > 1.01) {
              event.preventDefault();
              productLightboxZoom.translateX = productLightboxZoom.startTranslateX + (event.touches[0].clientX - productLightboxZoom.startX);
              productLightboxZoom.translateY = productLightboxZoom.startTranslateY + (event.touches[0].clientY - productLightboxZoom.startY);
              applyProductLightboxZoom();
              productLightboxTouch.moved = true;
              return;
            }

            var deltaX = event.touches[0].clientX - productLightboxTouch.startX;
            var deltaY = event.touches[0].clientY - productLightboxTouch.startY;
            if (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8) {
              productLightboxTouch.moved = true;
            }
          }, { passive: false });

          productLightboxStage.addEventListener('touchend', function (event) {
            if (!event.changedTouches || !event.changedTouches.length) {
              return;
            }

            if (productLightboxTouch.mode === 'pinch' || productLightboxTouch.mode === 'pan') {
              if (productLightboxZoom.scale <= 1.04) {
                resetProductLightboxZoom();
              } else {
                applyProductLightboxZoom();
              }
              productLightboxTouch.mode = '';
              window.setTimeout(function () {
                productLightboxTouch.moved = false;
              }, 220);
              return;
            }

            var touch = event.changedTouches[0];
            var deltaX = touch.clientX - productLightboxTouch.startX;
            var deltaY = touch.clientY - productLightboxTouch.startY;
            var currentItem = productLightboxItems[productLightboxIndex];
            var now = Date.now();
            var tapDistance = Math.abs(touch.clientX - productLightboxZoom.lastTapX) + Math.abs(touch.clientY - productLightboxZoom.lastTapY);

            if (currentItem && currentItem.type === 'image' && Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10 && now - productLightboxZoom.lastTapTime < 320 && tapDistance < 42) {
              event.preventDefault();
              var mediaRect = productLightboxMedia.getBoundingClientRect();
              if (productLightboxZoom.scale > 1.01) {
                resetProductLightboxZoom();
              } else {
                var targetScale = 2.35;
                var offsetX = touch.clientX - (mediaRect.left + mediaRect.width / 2);
                var offsetY = touch.clientY - (mediaRect.top + mediaRect.height / 2);
                setProductLightboxZoom(targetScale, -offsetX * (targetScale - 1), -offsetY * (targetScale - 1));
              }
              productLightboxTouch.moved = true;
              productLightboxZoom.lastTapTime = 0;
              window.setTimeout(function () {
                productLightboxTouch.moved = false;
              }, 220);
              return;
            }

            productLightboxZoom.lastTapTime = now;
            productLightboxZoom.lastTapX = touch.clientX;
            productLightboxZoom.lastTapY = touch.clientY;

            if (productLightboxZoom.scale <= 1.01 && Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
              showProductLightboxItem(deltaX < 0 ? 1 : -1);
              productLightboxTouch.moved = true;
              window.setTimeout(function () {
                productLightboxTouch.moved = false;
              }, 220);
            }

            productLightboxTouch.mode = '';
          }, { passive: false });
        }
      }

      preloadGalleryImages();

      if (minusButton) {
        minusButton.addEventListener('click', function () {
          updateQuantity(-1);
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function () {
          updateQuantity(1);
        });
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', normalizeQuantity);
        quantityInput.addEventListener('blur', normalizeQuantity);
      }

      if (addButton) {
        addButton.addEventListener('click', function () {
          checkoutRequested = false;
        });
      }

      if (buyButton) {
        buyButton.addEventListener('click', function () {
          checkoutRequested = true;
        });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          var submitter = event.submitter || document.activeElement;
          var selectedOptions = getSelectedOptions();
          var variant = getVariantByOptions(selectedOptions);

          if (!isLamassatVariantAvailable(variant)) {
            event.preventDefault();
            setAddButtonState(variant);
            showProductStockMessage();
            return;
          }

          var isCheckout = submitter === buyButton || checkoutRequested;

          // Progressive enhancement: add via AJAX and open the cart drawer.
          if (LamassatCart && window.fetch) {
            event.preventDefault();
            var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

            LamassatCart.add({ isDemo: false, variantId: variant.id, quantity: quantity })
              .then(function () {
                if (isCheckout) {
                  window.location.href = '/checkout';
                }
              })
              .catch(function () {
                // Fall back to a native form submit if the AJAX add fails.
                if (returnToInput) {
                  returnToInput.value = isCheckout ? '/checkout' : '';
                }
                form.submit();
              });

            return;
          }

          if (returnToInput) {
            returnToInput.value = isCheckout ? '/checkout' : '';
          }
        });
      }

      Array.prototype.slice.call(section.querySelectorAll('[data-product-accordion-trigger]')).forEach(function (trigger) {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (panel) {
          panel.setAttribute('aria-hidden', 'true');
          panel.style.maxHeight = '0px';
        }

        trigger.addEventListener('click', function () {
          toggleAccordion(trigger);
        });
      });

      sizeGuideOpeners.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          openSizeGuideModal(button);
        });
      });

      sizeGuideCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeSizeGuideModal);
      });

      Array.prototype.slice.call(section.querySelectorAll('[data-size-guide-link]')).forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (sizeGuideModal) {
            event.preventDefault();
            openSizeGuideModal(link);
            return;
          }

          var target = document.querySelector(link.getAttribute('href'));
          var trigger = target ? target.querySelector('[data-product-accordion-trigger]') : null;

          if (trigger) {
            toggleAccordion(trigger, true);
          }
        });
      });

      updateVariant();
    });
  };

  // ---------------------------------------------------------------------------
  // Cart: drawer + full page + live header counter.
  // Works with the real Shopify AJAX cart AND a client-side demo cart for the
  // dummy products used before the store is wired up to Shopify.
  // ---------------------------------------------------------------------------
  var LamassatCart = (function () {
    var settings = window.Lamassat || {};
    var routes = settings.routes || {};
    var DEMO_KEY = 'lamassatDemoCart';

    var state = { items: [], itemCount: 0, subtotalLabel: '', isEmpty: true, hasReal: false, hasDemo: false };
    var drawer = null;

    var trashSvg = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 7h14"></path><path d="M9 7V5h6v2"></path><path d="M7 7l1 12h8l1-12"></path></svg>';

    // --- money helpers -------------------------------------------------------
    // Demo prices arrive as strings like "289.000 TND" -> integer millimes (289000).
    var parseDemoPrice = function (value) {
      var digits = String(value || '').replace(/[^\d]/g, '');
      return digits ? parseInt(digits, 10) : 0;
    };

    var formatDemoPrice = function (millimes) {
      var safe = Math.max(0, Math.round(millimes || 0));
      var fixed = (safe / 1000).toFixed(3);
      var parts = fixed.split('.');
      var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return ensureTndCurrency(grouped + '.' + parts[1]);
    };

    // Shopify cart.js prices are integers in the currency subunit (amount * 100).
    // TODO: revisit precision for 3-decimal currencies (e.g. TND) once real products exist.
    var formatShopifyPrice = function (cents) {
      var amount = (cents || 0) / 100;
      var safe = Math.max(0, amount);
      var fixed = safe.toFixed(3);
      var parts = fixed.split('.');
      var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return ensureTndCurrency(grouped + '.' + parts[1]);
    };

    // --- demo backend (localStorage) ----------------------------------------
    var readDemo = function () {
      try {
        var parsed = JSON.parse(window.localStorage.getItem(DEMO_KEY));
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    var writeDemo = function (items) {
      try {
        window.localStorage.setItem(DEMO_KEY, JSON.stringify(items));
      } catch (error) {
        return;
      }
    };

    var demoKey = function (title, variant) {
      return 'demo:' + String(title || '').toLowerCase().trim() + ':' + String(variant || '').toLowerCase().trim();
    };

    var addDemo = function (item) {
      var items = readDemo();
      var key = demoKey(item.title, item.variant);
      var existing = items.filter(function (entry) { return entry.key === key; })[0];

      if (existing) {
        existing.quantity += item.quantity;
      } else {
        items.push({
          key: key,
          title: item.title,
          variant: item.variant || '',
          priceMillimes: item.priceMillimes || 0,
          image: item.image || '',
          url: item.url || (routes.allProducts || '/'),
          quantity: item.quantity
        });
      }

      writeDemo(items);
    };

    var changeDemo = function (key, quantity) {
      var items = readDemo();

      if (quantity <= 0) {
        items = items.filter(function (entry) { return entry.key !== key; });
      } else {
        var entry = items.filter(function (e) { return e.key === key; })[0];
        if (entry) { entry.quantity = quantity; }
      }

      writeDemo(items);
    };

    // --- shopify backend -----------------------------------------------------
    var fetchShopifyCart = function () {
      if (!routes.cart || !window.fetch) { return Promise.resolve(null); }

      return window.fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    };

    // --- normalized state ----------------------------------------------------
    var buildState = function (shopifyCart, demoItems) {
      var items = [];
      var realCount = 0;
      var realSubtotal = 0;
      var demoCount = 0;
      var demoSubtotal = 0;

      if (shopifyCart && shopifyCart.items) {
        shopifyCart.items.forEach(function (line) {
          var variantTitle = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
          items.push({
            key: line.key,
            isDemo: false,
            title: line.product_title || line.title,
            variant: variantTitle,
            url: line.url,
            image: line.image || (line.featured_image && line.featured_image.url) || '',
            quantity: line.quantity,
            unitLabel: formatShopifyPrice(line.final_price),
            lineLabel: formatShopifyPrice(line.final_line_price)
          });
          realCount += line.quantity;
        });
        realSubtotal = typeof shopifyCart.items_subtotal_price === 'number' ? shopifyCart.items_subtotal_price : shopifyCart.total_price;
      }

      demoItems.forEach(function (entry) {
        demoCount += entry.quantity;
        demoSubtotal += entry.priceMillimes * entry.quantity;
        items.push({
          key: entry.key,
          isDemo: true,
          title: entry.title,
          variant: entry.variant || '',
          url: entry.url || (routes.allProducts || '/'),
          image: entry.image || '',
          quantity: entry.quantity,
          unitLabel: formatDemoPrice(entry.priceMillimes),
          lineLabel: formatDemoPrice(entry.priceMillimes * entry.quantity)
        });
      });

      var subtotalLabel;
      if (realCount && demoCount) {
        subtotalLabel = formatShopifyPrice(realSubtotal) + ' + ' + formatDemoPrice(demoSubtotal);
      } else if (demoCount) {
        subtotalLabel = formatDemoPrice(demoSubtotal);
      } else {
        subtotalLabel = formatShopifyPrice(realSubtotal);
      }

      return {
        items: items,
        itemCount: realCount + demoCount,
        subtotalLabel: subtotalLabel,
        isEmpty: (realCount + demoCount) === 0,
        hasReal: realCount > 0,
        hasDemo: demoCount > 0
      };
    };

    // --- markup builders -----------------------------------------------------
    var buildQtyControl = function (line) {
      return [
        '<div class="lamassat-cart-qty" data-cart-qty>',
        '<button type="button" data-cart-minus aria-label="Diminuer la quantit&eacute;">&minus;</button>',
        '<input type="number" min="0" inputmode="numeric" value="' + line.quantity + '" data-cart-qty-input aria-label="Quantit&eacute;">',
        '<button type="button" data-cart-plus aria-label="Augmenter la quantit&eacute;">+</button>',
        '</div>'
      ].join('');
    };

    var lineAttributes = function (line) {
      return 'data-cart-line data-line-key="' + escapeHtml(line.key) + '" data-line-demo="' + (line.isDemo ? 'true' : 'false') + '"';
    };

    var buildDrawerLine = function (line) {
      var url = escapeHtml(line.url || '#');
      return [
        '<div class="lamassat-cart-line" role="listitem" ' + lineAttributes(line) + '>',
        '<a class="lamassat-cart-line__media' + (line.image ? '' : ' is-empty') + '" href="' + url + '" tabindex="-1" aria-hidden="true">',
        line.image ? '<img src="' + escapeHtml(line.image) + '" alt="" loading="lazy">' : '<span aria-hidden="true">Lamassat</span>',
        '</a>',
        '<div class="lamassat-cart-line__info">',
        '<div class="lamassat-cart-line__head">',
        '<a class="lamassat-cart-line__title" href="' + url + '">' + escapeHtml(line.title) + '</a>',
        '<button class="lamassat-cart-line__remove" type="button" data-cart-remove aria-label="Retirer ' + escapeHtml(line.title) + '">' + trashSvg + '</button>',
        '</div>',
        line.variant ? '<p class="lamassat-cart-line__variant">' + escapeHtml(line.variant) + '</p>' : '',
        '<div class="lamassat-cart-line__bottom">',
        buildQtyControl(line),
        '<span class="lamassat-cart-line__price">' + escapeHtml(line.lineLabel) + '</span>',
        '</div>',
        '</div>',
        '</div>'
      ].join('');
    };

    var buildPageLine = function (line) {
      var url = escapeHtml(line.url || '#');
      return [
        '<div class="lamassat-cart-row" role="listitem" ' + lineAttributes(line) + '>',
        '<div class="lamassat-cart-row__product">',
        '<a class="lamassat-cart-row__media' + (line.image ? '' : ' is-empty') + '" href="' + url + '">',
        line.image ? '<img src="' + escapeHtml(line.image) + '" alt="' + escapeHtml(line.title) + '" loading="lazy">' : '<span class="lamassat-cart-row__placeholder" aria-hidden="true">Lamassat</span>',
        '</a>',
        '<div class="lamassat-cart-row__details">',
        '<a class="lamassat-cart-row__title" href="' + url + '">' + escapeHtml(line.title) + '</a>',
        line.variant ? '<p class="lamassat-cart-row__variant">' + escapeHtml(line.variant) + '</p>' : '',
        '<p class="lamassat-cart-row__price-inline">' + escapeHtml(line.unitLabel) + '</p>',
        '<button class="lamassat-cart-row__remove" type="button" data-cart-remove aria-label="Retirer ' + escapeHtml(line.title) + '">' + trashSvg + '<span>Retirer</span></button>',
        '</div>',
        '</div>',
        '<div class="lamassat-cart-row__price">' + escapeHtml(line.unitLabel) + '</div>',
        '<div class="lamassat-cart-row__qty">' + buildQtyControl(line) + '</div>',
        '<div class="lamassat-cart-row__total">' + escapeHtml(line.lineLabel) + '</div>',
        '</div>'
      ].join('');
    };

    // --- rendering -----------------------------------------------------------
    var updateCounters = function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-cart-count], [data-cart-count-inline]')).forEach(function (node) {
        node.textContent = state.itemCount;
        node.hidden = state.itemCount === 0;
      });
    };

    var renderDrawer = function () {
      drawer = drawer || document.querySelector('[data-cart-drawer]');
      if (!drawer) { return; }

      var itemsHost = drawer.querySelector('[data-cart-drawer-items]');
      var empty = drawer.querySelector('[data-cart-drawer-empty]');
      var footer = drawer.querySelector('[data-cart-drawer-footer]');
      var subtotal = drawer.querySelector('[data-cart-subtotal]');
      var demoBanner = drawer.querySelector('[data-cart-demo-banner]');
      var demoNote = drawer.querySelector('[data-cart-demo-note]');

      if (itemsHost) { itemsHost.innerHTML = state.items.map(buildDrawerLine).join(''); }
      if (empty) { empty.hidden = !state.isEmpty; }
      if (footer) { footer.hidden = state.isEmpty; }
      if (subtotal) { subtotal.textContent = state.subtotalLabel; }
      if (demoBanner) { demoBanner.hidden = !state.hasDemo; }
      if (demoNote) { demoNote.hidden = true; } // shown only on a checkout attempt
    };

    var renderPage = function () {
      var page = document.querySelector('[data-cart-page]');
      if (!page) { return; }

      var layout = page.querySelector('[data-cart-page-layout]');
      var itemsHost = page.querySelector('[data-cart-page-items]');
      var empty = page.querySelector('[data-cart-page-empty]');
      var subtotal = page.querySelector('[data-cart-subtotal]');
      var demoBanner = page.querySelector('[data-cart-demo-banner]');
      var demoNote = page.querySelector('[data-cart-demo-note]');

      if (itemsHost) { itemsHost.innerHTML = state.items.map(buildPageLine).join(''); }
      if (layout) { layout.hidden = state.isEmpty; }
      if (empty) { empty.hidden = !state.isEmpty; }
      if (subtotal) { subtotal.textContent = state.subtotalLabel; }
      if (demoBanner) { demoBanner.hidden = !state.hasDemo; }
      if (demoNote) { demoNote.hidden = true; } // shown only on a checkout attempt
    };

    var render = function () {
      updateCounters();
      renderDrawer();
      renderPage();
    };

    var refresh = function () {
      return Promise.all([fetchShopifyCart(), Promise.resolve(readDemo())]).then(function (results) {
        state = buildState(results[0], results[1]);
        render();
        return state;
      });
    };

    // --- drawer open/close ---------------------------------------------------
    var openDrawer = function () {
      drawer = drawer || document.querySelector('[data-cart-drawer]');
      if (!drawer) { return; }

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lamassat-no-scroll');

      var closeButton = drawer.querySelector('[data-cart-drawer-close]');
      if (closeButton && closeButton.focus) {
        try { closeButton.focus({ preventScroll: true }); } catch (error) { closeButton.focus(); }
      }
    };

    var closeDrawer = function () {
      drawer = drawer || document.querySelector('[data-cart-drawer]');
      if (!drawer) { return; }

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lamassat-no-scroll');
    };

    // --- mutations -----------------------------------------------------------
    var add = function (payload) {
      var quantity = Math.max(1, Math.floor(payload.quantity || 1));

      if (payload.isDemo) {
        addDemo({
          title: payload.title,
          variant: payload.variant || '',
          priceMillimes: payload.priceMillimes || 0,
          image: payload.image || '',
          url: payload.url || '',
          quantity: quantity
        });
        return refresh().then(function (result) { openDrawer(); return result; });
      }

      if (!routes.cartAdd || !window.fetch) { return Promise.reject(new Error('No cart route')); }

      return window.fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: payload.variantId, quantity: quantity }] })
      }).then(function (response) {
        if (!response.ok) { throw new Error('Cart add failed'); }
        return response.json();
      }).then(function () {
        return refresh();
      }).then(function (result) {
        openDrawer();
        return result;
      });
    };

    var changeLine = function (line, quantity) {
      var next = Math.max(0, Math.floor(quantity));

      if (line.isDemo) {
        changeDemo(line.key, next);
        return refresh();
      }

      if (!routes.cartChange || !window.fetch) { return refresh(); }

      return window.fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: next })
      }).then(function (response) {
        return response.ok ? response.json() : null;
      }).then(function () {
        return refresh();
      });
    };

    var goToCheckout = function () {
      if (state.hasReal) {
        window.location.href = '/checkout';
        return;
      }

      var note = drawer && drawer.querySelector('[data-cart-demo-note]');
      if (note) { note.hidden = false; }
    };

    // --- events --------------------------------------------------------------
    var getLineRef = function (target) {
      var el = target.closest('[data-cart-line]');
      if (!el) { return null; }
      return {
        key: el.getAttribute('data-line-key'),
        isDemo: el.getAttribute('data-line-demo') === 'true',
        el: el
      };
    };

    var bindContainer = function (root) {
      if (!root) { return; }

      root.addEventListener('click', function (event) {
        var minus = event.target.closest('[data-cart-minus]');
        var plus = event.target.closest('[data-cart-plus]');
        var remove = event.target.closest('[data-cart-remove]');

        if (!minus && !plus && !remove) { return; }

        var ref = getLineRef(event.target);
        if (!ref) { return; }
        event.preventDefault();

        var input = ref.el.querySelector('[data-cart-qty-input]');
        var current = input ? Math.max(0, parseInt(input.value, 10) || 0) : 1;

        if (remove) { changeLine(ref, 0); return; }
        if (minus) { changeLine(ref, current - 1); return; }
        if (plus) { changeLine(ref, current + 1); return; }
      });

      root.addEventListener('change', function (event) {
        if (!event.target.matches('[data-cart-qty-input]')) { return; }
        var ref = getLineRef(event.target);
        if (!ref) { return; }
        changeLine(ref, parseInt(event.target.value, 10) || 0);
      });
    };

    // --- init ----------------------------------------------------------------
    var init = function () {
      drawer = document.querySelector('[data-cart-drawer]');

      if (drawer) {
        bindContainer(drawer);

        Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-drawer-close]')).forEach(function (button) {
          button.addEventListener('click', function () { closeDrawer(); });
        });

        var checkout = drawer.querySelector('[data-cart-drawer-checkout]');
        if (checkout) { checkout.addEventListener('click', goToCheckout); }
      }

      // Cart icon(s) open the drawer instead of navigating to /cart.
      Array.prototype.slice.call(document.querySelectorAll('[data-cart-toggle]')).forEach(function (toggle) {
        toggle.addEventListener('click', function (event) {
          if (!drawer) { return; }
          event.preventDefault();
          openDrawer();
          refresh();
        });
      });

      // Full cart page.
      var page = document.querySelector('[data-cart-page]');
      if (page) {
        bindContainer(page);

        var pageCheckout = page.querySelector('[data-cart-page-checkout]');
        if (pageCheckout) {
          pageCheckout.addEventListener('click', function (event) {
            if (state.hasReal) { return; } // real cart → let the native form submit to Shopify
            event.preventDefault();
            var note = page.querySelector('[data-cart-demo-note]');
            if (note) { note.hidden = false; }
          });
        }
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      refresh();
    };

    return {
      init: init,
      add: add,
      refresh: refresh,
      openDrawer: openDrawer,
      closeDrawer: closeDrawer,
      parseDemoPrice: parseDemoPrice
    };
  })();

  window.LamassatCart = LamassatCart;

  // ---------------------------------------------------------------------------
  // Search: header overlay (live predictive results) + full results page.
  // Currently powered by the demo catalog; swaps to real Shopify search later.
  // ---------------------------------------------------------------------------
  var initSearch = function () {
    var searchUrl = (window.Lamassat && window.Lamassat.routes && window.Lamassat.routes.search) || '/search';

    // --- Overlay: live predictive search (Shopify /search/suggest.json) ------
    var overlay = document.querySelector('[data-search-overlay]');
    if (overlay) {
      var input = overlay.querySelector('[data-search-input]');
      var live = overlay.querySelector('[data-search-live]');
      var hint = overlay.querySelector('[data-search-hint]');
      var emptyMsg = overlay.querySelector('[data-search-empty]');
      var allLink = overlay.querySelector('[data-search-all]');
      var allLabel = overlay.querySelector('.lamassat-search__all-label');
      var clearButton = overlay.querySelector('[data-search-clear]');
      var lastFocus = null;

      var requestSeq = 0;

      var buildResult = function (product) {
        var image = (product.featured_image && product.featured_image.url) || product.image || '';
        var price = typeof product.price === 'string' ? ensureTndCurrency(product.price) : '';
        var compare = typeof product.compare_at_price === 'string' ? ensureTndCurrency(product.compare_at_price) : '';
        var onSale = compare && compare !== price;
        return [
          '<a class="lamassat-search__result" href="' + escapeHtml(product.url || '#') + '" role="listitem">',
          '<span class="lamassat-search__result-media">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '') + '</span>',
          '<span class="lamassat-search__result-info">',
          '<span class="lamassat-search__result-title">' + escapeHtml(product.title || '') + '</span>',
          price ? '<span class="lamassat-search__result-price' + (onSale ? ' is-sale' : '') + '">' + escapeHtml(price) + (onSale ? ' <s>' + escapeHtml(compare) + '</s>' : '') + '</span>' : '',
          '</span>',
          '</a>'
        ].join('');
      };

      var resetOverlay = function () {
        if (clearButton) { clearButton.hidden = true; }
        if (live) { live.innerHTML = ''; }
        if (hint) { hint.hidden = false; }
        if (emptyMsg) { emptyMsg.hidden = true; }
        if (allLink) { allLink.hidden = true; }
      };

      var renderResults = function (products, query) {
        if (hint) { hint.hidden = true; }

        if (!products || !products.length) {
          if (live) { live.innerHTML = ''; }
          if (emptyMsg) { emptyMsg.hidden = false; }
        } else {
          if (emptyMsg) { emptyMsg.hidden = true; }
          if (live) { live.innerHTML = products.slice(0, 6).map(buildResult).join(''); }
        }

        if (allLink) {
          allLink.hidden = false;
          allLink.href = searchUrl + '?q=' + encodeURIComponent(query);
          if (allLabel) {
            allLabel.textContent = (products && products.length) ? 'Voir tous les résultats' : 'Rechercher « ' + query + ' »';
          }
        }
      };

      var doSearch = function () {
        var query = input ? input.value.trim() : '';
        if (clearButton) { clearButton.hidden = query.length === 0; }

        if (!query) { resetOverlay(); return; }
        if (!window.fetch) { renderResults([], query); return; }

        var seq = ++requestSeq;
        var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        window.fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (data) {
            if (seq !== requestSeq) { return; }
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products, query);
          })
          .catch(function () {
            if (seq === requestSeq) { renderResults([], query); }
          });
      };

      var openOverlay = function () {
        lastFocus = document.activeElement;
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lamassat-no-scroll');
        if (input && input.value.trim()) { doSearch(); } else { resetOverlay(); }
        if (input) {
          window.setTimeout(function () {
            try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
          }, 60);
        }
      };

      var closeOverlay = function () {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lamassat-no-scroll');
        if (lastFocus && lastFocus.focus) {
          try { lastFocus.focus({ preventScroll: true }); } catch (error) { lastFocus.focus(); }
        }
      };

      Array.prototype.slice.call(document.querySelectorAll('[data-search-toggle]')).forEach(function (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          openOverlay();
        });
      });

      Array.prototype.slice.call(overlay.querySelectorAll('[data-search-close]')).forEach(function (button) {
        button.addEventListener('click', closeOverlay);
      });

      if (input) {
        var debounceTimer = null;
        input.addEventListener('input', function () {
          window.clearTimeout(debounceTimer);
          debounceTimer = window.setTimeout(doSearch, 200);
        });
      }

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          if (input) {
            input.value = '';
            input.focus();
          }
          resetOverlay();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
          closeOverlay();
        }
      });
    }
    // Results page is server-rendered from Shopify search results (main-search.liquid).
  };

  ready(function () {
    initOpener();
    initHeader();
    initFooterAccordions();
    initHeroSlider();
    initDemoPdpPreview();
    initQuickView();
    initProductPage();
    LamassatCart.init();
    initSearch();
  });
})();
